export default {
  scriptOps: {"title":"Script optimization","scope":"Select scenes to optimize a fragment; leave all unchecked for the full episode. Results require review.","operator":"Operator","opening":"Strengthen opening","conflict":"Strengthen conflict","satisfaction":"Strengthen payoffs","reversal":"Strengthen reversal","hook":"Strengthen hook","cinematic":"Improve cinematic framing","shorten":"Shorten","running":"Optimizing","apply":"Generate optimized version","saved":"Saved for review","lengthDrift":"Length changed beyond the advisory threshold. Review the result."},
  visualIdentity: {title: 'Visual identity anchors', bone_structure: 'Bone structure', facial_features: 'Facial features', marks: 'Distinctive marks', colors: 'Colors', texture: 'Texture', hair: 'Hair', clothing: 'Clothing'},
  refOutdated: {empty: 'No current images need regeneration.', invalid: 'Could not read reference update details.', title: 'Reference updated; regeneration suggested', legacy: 'Inferred dependency', exact: 'Original reference changed'},

  contextWarnings: {unrecorded: "Generation continued, but context truncation records could not be saved.",sources:{"screenplay_json":"Screenplay","rag":"Retrieved context","canon":"Canon","chapter_history":"Chapter history","chapter_text":"Chapter text","storyboard":"Storyboard","screenplay":"Screenplay"},reasons:{"pretrim_budget_exceeded":"Screenplay exceeds the context budget","source_budget_exceeded":"Source budget exceeded","total_budget_exceeded":"Total context budget exhausted","total_budget_truncated":"Shortened to fit remaining budget","empty_content":"Empty content"},other:"Other reason","title":"Context omitted or shortened for this chapter","truncated":"Truncated","dropped":"Dropped","failed":"Could not load context details. Please retry."},
 mediaProvenance: {"title":"This film includes substitute or simplified content","storyboard":"This is a storyboard version","other":"Other reason: {{reason}}","reasons":{"context_warnings_unrecorded":"Generation continued, but context truncation records could not be saved.","degraded_clip_unavailable":"Video clip unavailable; storyboard images were used","degraded_panel_placeholder":"Panel image unavailable; a placeholder was used","degraded_no_subtitle":"Subtitles were not generated","degraded_subtitle_error":"Subtitle generation failed","degraded_bgm_unavailable":"Background music unavailable","degraded_audio_mix":"Audio mixing failed; the original track was used","degraded_clip_stretch":"Video clip duration was adjusted"}},
 projectBudget: {submissionWarnings: "{{count}} recent submissions approached the project budget limit.",stages:{"text":"Text","image":"Images","panel":"Panel images","audio":"Audio","video":"Video","other":"Other"},"title":"Project budget limit","unlimited":"Unlimited","hint":"Leave blank for no limit. Active reservations count toward the limit. Conservative estimates may block tasks whose actual cost would be lower.","invalid":"Enter a non-negative integer or leave blank.","failed":"Could not load or save the budget","usage":"Spent {{spent}} credits · Reserved {{active}} credits","warning":"Approaching the project budget limit","exceeded":"Project budget exceeded"},
  diegeticEditor: {
    title: 'Adjust paper text', save: 'Save changes', reset: 'Reset', cancel: 'Cancel',
    help: 'Drag a carrier box or its corners. Save applies all edited boxes on this page; Reset restores all boxes to their original positions. Arrow keys move a focused box; Shift + arrow keys resize it.',
    fallback: 'Boxes without a detected position start in the centre of their panel. Move them onto the paper before saving.',
    carrier: 'Carrier {{number}}', move: 'Move carrier {{number}}',
    nw: 'Resize top left corner', ne: 'Resize top right corner', sw: 'Resize bottom left corner', se: 'Resize bottom right corner',
    saving: 'Saving positions…', composing: 'Positions saved. Composing and waiting for the updated page…',
    loadFailed: 'Could not load editable text positions. Retry to adjust this page.',
    saveFailed: 'Could not save all positions. Your edits are still here; retry saving or reset.',
    composeFailed: 'Positions were saved, but the updated page could not be confirmed. Retry saving or reset to compose again.',
  },
  pagePreflight: { loading: 'Checking composition prerequisites', failed: 'Could not check prerequisites. Refresh to retry.', storyboard: 'Storyboard needs approval', storyboard_panels: 'Storyboard has no panels', panelImage: 'Panel {{id}} has no image' },
  pagePreview: { title: 'Finished pages', page: 'Page {{page}} / {{total}}', fallback: 'Fell back to a fixed layout', degraded: 'Degradation reasons', imageFailed: 'Image failed to load. Reload the page to retry.', refresh: 'Refresh', loading: 'Loading finished pages…', loadFailed: 'Could not load finished pages. Please retry.', empty: 'No finished pages yet', compose: 'Compose pages', submitting: 'Submitting…', queued: 'Composition queued. Refresh when it finishes.', composeFailed: 'Could not submit composition. Please retry.' },
  creatorReview: { approve: 'Approve', reject: 'Reject', reason: 'Review reason (required to reject)', saved: 'Review saved. Start the next station manually.' },
  characterDesign: {
    discard: 'Discard candidate',
    instructions: 'Save an appearance, draw candidates, then compare four views and lock your choice.', appearance: 'Appearance', save: 'Save appearance', suggest: 'AI suggestion', draw: 'Draw candidate', replay: 'Reproduce candidate', lock: 'Select and lock', locked: 'Locked', candidate: 'Candidate', failed: 'Generation failed', seed: 'Seed', generating: 'Generating four views', loading: 'Loading', missingAppearance: '{{name}}: appearance missing', unsaved: 'Save your appearance changes before drawing.', noCharacters: 'No classified characters. Review entity classifications first.', noCandidates: 'No candidates yet. Save an appearance to start drawing.', imageUnavailable: 'Image unavailable', imageAlt: '{{name}} four-view candidate', classification: 'Classify and correct entities', classify: 'Classify uncategorized entities', kind: 'Kind', kinds: { character: 'Character', prop: 'Prop', location: 'Location', organization: 'Organization', unknown: 'Needs classification' },
  },
  sceneLock: { title: 'Scene locks', create: 'New', save: 'Save lock', saved: 'Scene lock saved', saveFailed: 'Could not save scene lock', id: 'Scene ID', setting: 'Setting', weather: 'Weather', lighting: 'Lighting', props: 'Props', reason: 'Override reason' },
  refinement: { candidate: "Refinement candidate", referenceWarning: 'The refinement changed pronouns or character references. Review before adopting.', history: 'Version history', volumeTXT: 'Volume TXT', exportVolumeTXT: 'Export current volume as TXT' },
  cascadeEstimate: { noData: 'No data yet', failed: 'Estimate unavailable' },
  foreshadowDebt: {pending: 'Pending decisions: {{count}} (required before confirmation)', suggestion: 'Reschedule to the volume end, mark long-term with a later chapter, or delete.', rescheduleAll: 'Reschedule all to volume end', noFutureVolumeEnd: 'No later volume end is available. Decide each item individually.',decisions: 'Assign a payoff volume, mark long-term, or delete each foreshadow', title: 'Required payoffs', limit: 'New foreshadows allowed: {{count}}', empty: 'No foreshadows are due.', target: 'New payoff chapter', reschedule: 'Reschedule', long: 'Mark long-term', delete: 'Delete foreshadow', failed: 'Could not save decision'},
  contentMode: {
    label: 'Creation mode',
    current: 'Now: {{value}}',
    currentLabel: 'Now',
    easy: 'Easy',
    advanced: 'Advanced',
  },
  autopilot: {
    title: 'Autopilot',
    status: {
      planning: 'Preparing', running: 'Writing', paused: 'Paused', blocked_plan: 'Outline needed',
      blocked_credits: 'Credits needed', completed: 'Completed', failed: 'Failed', cancelled: 'Ended',
    },
    progress: 'Chapter {{current}}/{{end}}{{title}} · {{spent}}/{{estimated}} credits spent',
    lastQuality: 'Latest quality: {{score}}',
    nextCheckpoint: 'Next stop: chapter {{chapter}}',
    pause: 'Stop',
    resume: 'Continue writing',
    editOutline: 'Edit outline, then continue',
    cancel: 'End run',
    checkpointTitle: 'Generated prose at this stop',
    chapterTitle: 'Chapter {{chapter}} · {{title}}',
    noProse: 'No generated prose is available yet.',
    actionFailed: 'Autopilot action failed.',
    reason: {
      budget: 'Project budget exceeded, including active reservations and conservative estimates.',
      checkpoint: 'The planned stop has been reached. Read the prose and choose what happens next.',
      credits: 'There are not enough credits. Add credits before continuing.',
      quality: 'Consecutive quality checks fell below the threshold. Choose what happens next.',
      needs_review: 'This chapter needs your confirmation before continuing.',
      job_failed: 'This chapter failed to generate. Retry or adjust to continue.',
      user: 'You paused autopilot.',
      invariant_violation: 'The run conditions changed. Review them before continuing.',
      andon: 'The andon safeguard stopped the run. Review the current prose.',
    },
  },
  app: { name: 'Novel-Factory', tagline: 'An industrial atelier for stories' },
  languageNames: {
    zh: 'Chinese',
    en: 'English',
    ja: 'Japanese',
    ko: 'Korean',
    fr: 'French',
    de: 'German',
    es: 'Spanish',
    it: 'Italian',
    ru: 'Russian',
    pt: 'Portuguese',
    ar: 'Arabic',
    th: 'Thai',
    vi: 'Vietnamese',
    id: 'Indonesian',
  },
  nav: {
    home: 'Home',
    projects: 'Projects',
    trash: 'Trash',
    board: 'Pulse Board',
    library: 'Works Library',
    consistency: 'Consistency',
    skills: 'Skills',
    billing: 'Billing',
    gameplay: 'Gameplay',
    admin: 'Admin',
  },
  login: {
    title: 'Sign in to Novel-Factory',
    subtitle: 'Cross-site domain · secure session',
    username: 'Username',
    password: 'Password',
    captchaLabel: 'Captcha',
    captchaRefresh: 'Refresh',
    captchaPlaceholder: 'Enter 6-digit captcha',
    captchaInvalid: 'Captcha is invalid or expired',
    submit: 'Sign in',
    submitting: 'Signing in',
    required: 'Enter username and password',
    failed: 'Sign-in failed. Check your username or password.',
  },
  shell: {
    bootstrapFailed: 'Try again later, or sign in again.',
    credits: 'Credits',
    creditsUnlimited: 'Billing disabled',
    creditsUnlimitedLabel: 'Unlimited',
    toggleTheme: 'Toggle theme',
    appVersion: 'System version',
    command: 'Command',
    commandShortcut: 'Ctrl K',
    userMenu: 'User menu',
    currentUser: 'Current user',
    commandTitle: 'Command palette',
    commandDescription: 'Jump to pages and run common actions',
    commandPlaceholder: 'Search commands or pages',
    commandEmpty: 'No matching commands',
    commandNavigate: 'Navigate',
    commandActions: 'Actions',
    lightMode: 'Light',
    darkMode: 'Dark',
    menuBilling: 'Billing & usage',
    menuAccountSettings: 'Account settings',
    menuAdmin: 'Admin console',
    adminBadge: 'Admin',
    healthNormal: 'normal',
    healthAbnormal: 'abnormal',
    healthUnchecked: 'not checked',
    healthTooltip: 'Backend service: {{status}}',
    healthCheckedAt: 'Last checked: {{time}}',
    helpManual: 'User manual',
  },
  home: {
    eyebrow: 'Overview',
    title: 'Command Center',
    subtitle: 'The daily creation status, action signals, and continuation paths that matter most.',
    metrics: {
      activeProjects: {
        title: 'Active Projects',
        detail: 'Open project list',
      },
      inFlight: {
        title: 'In-flight Chapters',
        detail: 'Open pulse board',
      },
      consistency: {
        title: 'Consistency Health',
        detail: '{{hard}} hard · {{soft}} soft · {{overridden}} exceptions',
        status: {
          healthy: 'Healthy',
          needsAttention: 'Needs Attention',
        },
      },
      credits: {
        title: 'Credit Balance',
        detail: 'Open billing',
      },
    },
    recent: {
      title: 'Recently Edited Projects',
      description: 'Sorted by update time so you can continue where work last happened.',
      genreFallback: 'No genre set',
      empty: 'No active projects yet',
      emptyHint: 'Create a project and recent editing shortcuts will appear here.',
    },
    quickActions: {
      title: 'Quick Actions',
      description: 'Frequent actions that go straight to the workspace.',
      newProject: 'New Project',
      board: 'Board',
      trash: 'Trash',
    },
    errors: {
      projects: 'Failed to load projects.',
      pulse: 'Failed to load in-flight status.',
      conflicts: 'Failed to load consistency status.',
      credits: 'Failed to load credit balance.',
    },
  },
  account: {
    changePassword: 'Change password',
    changePasswordDescription: 'Update the sign-in password for this account.',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    changingPassword: 'Changing',
    passwordChangeSuccess: 'Password changed',
    passwordChangeFailed: 'Failed to change password',
    passwordUnavailable: 'Password changes are not available in the current auth mode.',
    passwordRequired: 'Enter your current password, new password, and confirmation.',
    passwordMismatch: 'The new passwords do not match.',
  },
  common: {
    zoom: 'View larger',
    logout: 'Sign out',
    theme: 'Dark / Light',
    lang: '中文',
    loading: 'Loading…',
    workInProgress: 'This station lands in M1/M2',
    serviceError: 'Service is temporarily unavailable or the network failed',
    retry: 'Retry',
    create: 'Create',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
  },
  errors: {
    http: {
      401: 'Please sign in first',
      403: 'You do not have permission to access this',
      404: 'Resource not found',
      429: 'Too many requests',
      500: 'Service error. Try again later',
      502: 'Gateway error',
      503: 'Service temporarily unavailable',
      unknown: 'Request failed. Try again later',
    },
    codes: {
		chapter_exists: 'This chapter already exists. Refresh and select the next chapter.',
		invalid_genre: 'Choose a catalog genre or use a custom genre.',
		compose_prerequisites: 'Generate an approved storyboard and audio before composing.',
      foreshadow_decision_required: 'Assign a payoff volume, mark long-term, or delete each foreshadow',
      not_ready: 'Service is starting up. Please try again shortly',
      dispatcher_unavailable: 'Service is temporarily unavailable. Please try again later',
      chapter_service_unavailable: 'Chapter service is temporarily unavailable. Please try again later',
      memory_store_unavailable: 'Memory service is temporarily unavailable. Please try again later',
      config_error: 'Service configuration error. Please try again later',
      forbidden: 'You do not have permission to perform this action',
      unauthorized: 'Please sign in before continuing',
      project_budget_exceeded: "Project budget exceeded. The conservative estimate may exceed actual cost. Adjust the budget or wait for active tasks to settle.",
      insufficient_credits: 'Insufficient credits. Please top up and try again',
      outline_not_confirmed: 'Confirm the chapter outline before generating text',
      foreshadow_no_payoff: 'The skeleton plants foreshadowing but never pays any of it off. Go back to skeleton planning and assign a paying-off volume/chapter for each, then confirm again.',
      rate_limited: 'Too many requests. Please try again later',
      generation_failed: 'Generation failed. Please try again later',
      video_station_disabled: 'Video generation is not available yet',
      not_found: 'Resource not found or removed',
      internal: 'Service error. Please try again later',
      db_error: 'Service error. Please try again later',
      invalid_captcha: 'The captcha is incorrect or expired',
      invalid_json: 'Request content format is invalid. Please check and try again',
      invalid_request: 'Request content is incomplete. Please check and try again',
      missing_fields: 'Fill in the required information and try again',
      account_locked: 'This account is locked. Contact an administrator',
      redemption_code_used: 'This redemption code has already been used',
      username_exists: 'This username already exists. Choose another username',
      invalid_credentials: 'Username or password is incorrect',
    },
    boundary: {
      title: 'This area cannot be displayed right now',
      description: 'A page component encountered an error. You can refresh and try again; navigation and other areas remain available.',
      refresh: 'Refresh',
      chapterWorkspace: 'Chapter workspace cannot be displayed right now',
    },
  },
  assetLibrary: {
    searchPlaceholder: 'Search assets',
    loadFailed: 'Failed to load asset library',
    empty: 'No assets to display yet',
    source: 'Source',
    sourceChapter: 'Source chapter',
    chapterShort: 'Ch. {{chapter}}',
    openExisting: 'Open existing entry',
    types: {
      all: 'All',
      character: 'Characters',
      scene: 'Scenes',
      prop: 'Props',
      voice: 'Voices',
    },
    attributes: {
      role_type: 'Role',
      appearance: 'Appearance',
      visual_lock: 'Visual lock',
      last_seen_chapter: 'Last seen',
      scene_id: 'Scene ID',
      intent: 'Intent',
      weather: 'Weather',
      lighting: 'Lighting',
      override_reason: 'Lock reason',
      scenes: 'Scenes',
      strictness: 'Strictness',
      character: 'Character',
      voice: 'Voice',
      builtin: 'Built-in',
      gender: 'Gender',
      age_band: 'Age band',
      style: 'Style',
      source: 'Source',
      provider: 'Provider',
      model: 'Model',
      description: 'Description',
    },
  },
  qualityGate: {
    unscored: 'Unscored',
    assessmentFailed: 'Scoring failed',
    scoreShort: 'Q {{score}}',
    scoreValue: 'Quality {{score}}',
    regenerate: 'Regenerate',
    regenerateQueued: 'Quality regeneration submitted',
    emptyChapter: 'This chapter has no text to regenerate',
    loading: 'Loading quality history',
    noHistory: 'No quality history yet',
    cardTitle: 'Chapter quality score',
    overall: 'Overall score',
    suggestions: 'Suggestions',
    band: {
      excellent: 'Excellent',
      good: 'Good',
      review: 'Review',
      weak: 'Weak',
      failed: 'Failed',
    },
  },
  billing: {
    title: 'Billing',
    description: 'Review project usage, credit balance, and account ledger for the current user.',
    usage: {
      title: 'Usage Overview',
      description: 'Review credit usage by station, date, and model for the current account.',
      dailyTitle: 'Daily spending trend for this month',
      dailyDescription: 'Daily credit usage for the selected month. Bars show totals; the line shows trend.',
      byServiceTitle: 'By station',
      byServiceDescription: 'Credit share across production stations.',
      byModelTitle: 'By Model',
      monthCredits: 'Monthly Credits',
      monthCreditsSubtitle: 'Current month cumulative spend',
      cumulativeCredits: 'Cumulative Credits',
      cumulativeCreditsSubtitle: 'Account lifetime spend',
      modelCredits: 'Model Credits',
      modelCount: 'Models',
      month: 'Month',
      creditsUnit: 'Credits',
      serviceShareChart: 'Station credit share chart',
      sourceLocal: 'Local',
      sourceCloud: 'Cloud',
      colModel: 'Model',
      colSource: 'Source',
      colTokens: 'Tokens',
      colCredits: 'Credits',
      inputTokens: 'Input',
      outputTokens: 'Output',
      cachedInputTokens: 'Cached',
      partialTokenSplit: 'Some historical data has no token split',
      empty: 'No data',
      retry: 'Retry',
      services: {
        text: 'Text',
        screenplay: 'Screenplay',
        storyboard: 'Storyboard',
        image: 'Image',
        audio: 'Audio',
        video: 'Video',
      },
    },
    projects: {
      title: 'Project overview',
      description: 'Word usage across projects owned by the current user.',
      count: 'Projects',
      totalWords: 'Total words',
      empty: 'No projects yet.',
      error: 'Failed to load project usage.',
      statusUnknown: 'Unknown',
      table: {
        title: 'Title',
        words: 'Words',
        status: 'Status',
      },
    },
    credits: {
      title: 'Credits',
      description: 'Current billing balance for this account.',
      available: 'Available',
      balance: 'Balance',
      reserved: 'Reserved',
      disabled: 'Billing disabled',
      error: 'Failed to load credit balance.',
    },
    redeem: {
      title: 'Redeem code',
      placeholder: 'NF-XXXX-XXXX-XXXX-XXXX',
      submit: 'Redeem',
      required: 'Enter a redemption code.',
      success: 'Credits redeemed.',
      errors: {
        invalid: 'This code is invalid.',
        used: 'This code has already been used.',
        expired: 'This code has expired.',
      },
    },
    payment: {
      title: 'Payment',
      checkout: 'Checkout',
      comingSoon: 'Payment coming soon',
      preregister: 'Pre-register',
      preregistered: 'Top-up interest recorded. This version does not connect to real payments.',
      packages: {
        starter: {
          title: 'Creator Starter',
          description: 'For short trial runs across image, audio, and video stations.',
        },
        studio: {
          title: 'Studio Pack',
          description: 'For teams reserving credits for continuous chapter asset production.',
        },
      },
    },
    ledger: {
      title: 'Ledger',
      description: 'Recent credit adjustments and usage.',
      empty: 'No ledger transactions yet.',
      error: 'Failed to load credit ledger.',
      previous: 'Previous',
      next: 'Next',
      range: 'Rows {{start}}-{{end}}',
      single: 'Row {{index}}',
      table: {
        type: 'Type',
        amount: 'Amount',
        balanceAfter: 'Balance after',
        createdAt: 'Time',
      },
      types: {
        topup: 'Top-up',
        consume: 'Spend',
        refund: 'Refund',
        hold: 'Hold',
        release: 'Release hold',
        adjust: 'Adjustment',
      },
    },
  },
  admin: {
    title: 'Admin',
    subtitle: 'Manage system-level features that require an admin token. The token is stored only in this browser.',
    tokenTitle: 'Admin Token',
    tokenDescription:
      'Admin features require a second admin token check in addition to your signed-in account. The token is stored only in this browser.',
    tokenLabel: 'Token',
    tokenPlaceholder: 'Enter admin token',
    tokenConfiguredPlaceholder: 'Saved (leave blank to keep unchanged)',
    tokenConfigured: 'Verified',
    tokenMissing: 'Not configured',
    tokenVerifying: 'Verifying',
    tokenInvalid: 'Token invalid',
    tokenRequired: 'Enter an admin token',
    tokenSaved: 'Admin token saved and verification started',
    tokenCleared: 'Admin token cleared',
    saveToken: 'Save and verify',
    clearToken: 'Clear',
    openModels: 'Model settings',
    showToken: 'Show token',
    hideToken: 'Hide token',
  },
  adminConsole: {
    forbiddenTitle: 'Admin access required',
    forbiddenDescription: 'The current account is not an admin and cannot open admin-only pages.',
    tokenMissingTitle: 'Admin token required',
    tokenMissingDescription: 'Save an admin token first to enable user management, credit top-ups, and model settings from this console.',
    tokenVerifyingTitle: 'Verifying token…',
    tokenVerifyingDescription: 'Confirming with the server that the admin token is valid.',
    tokenInvalidTitle: 'Admin token is incorrect',
    tokenInvalidDescription: 'Admin token is incorrect, so access to admin features has been denied. Enter the correct token and try again.',
    tabs: {
      users: 'Users',
      usage: 'Usage',
      dashboard: 'Data dashboard',
      observability: 'Logs & performance',
      credits: 'Credits',
      models: 'Model settings',
      storage: 'Storage',
      backup: 'Backup',
    },
    dashboard: {
      title: 'Data dashboard',
      description: 'Open /admin/dashboard to inspect users, generation pipeline, LLM health, role routability, and backend probes.',
      open: 'Open data dashboard',
    },
    storage: {
      title: 'Storage',
      description: 'View backend and path mappings, and jump to storage connectivity check.',
      open: 'Open storage settings',
    },
    users: {
      title: 'User management',
      description: 'Search existing users, adjust trust level, admin rights, active status, and reset passwords.',
      searchPlaceholder: 'Search username, display name, or user ID',
      search: 'Search',
      empty: 'No users found',
      emptyRange: 'No users',
      range: 'Rows {{start}}-{{end}}',
      single: 'Row {{index}}',
      previous: 'Previous',
      next: 'Next',
      yes: 'Yes',
      no: 'No',
      active: 'Active',
      inactive: 'Inactive',
      resetPassword: 'Reset password',
      editTitle: 'Edit user',
      resetTitle: 'Reset user password',
      resetDescription: 'Set a new password for {{username}} and delete existing sessions.',
      newPassword: 'New password',
      newPasswordPlaceholder: 'At least 8 characters',
      adminOn: 'Admin: yes',
      adminOff: 'Admin: no',
      activeOn: 'Status: active',
      activeOff: 'Status: inactive',
      updateSuccess: 'User updated',
      resetSuccess: 'Password reset. Deleted {{count}} sessions',
      columns: {
        username: 'Username',
        displayName: 'Display name',
        trustLevel: 'Trust Level',
        isAdmin: 'Admin',
        isActive: 'Status',
        createdAt: 'Created',
        actions: 'Actions',
      },
      errors: {
        invalidTrustLevel: 'Trust level must be an integer greater than or equal to 0',
        passwordTooShort: 'New password must be at least 8 characters',
        lastAdminProtected: 'The last active admin cannot be demoted or disabled',
        userNotFound: 'User not found',
      },
    },
    credits: {
      title: 'Credit top-up',
      description: 'Top up credits for a specific user. Each submission auto-generates an idempotency key.',
      userId: 'User ID',
      userIdPlaceholder: 'Search username or paste user ID',
      userSearchLoading: 'Searching users…',
      userSearchEmpty: 'No matching users',
      userSearchMeta: '{{displayName}} · {{userId}}',
      amount: 'Amount',
      note: 'Note',
      notePlaceholder: 'Optional audit note',
      submit: 'Top up',
      topUpSuccess: 'Credits topped up',
      errors: {
        userRequired: 'Enter user ID',
        amountInvalid: 'Top-up amount must be greater than 0',
      },
    },
    observability: {
      perfTitle: 'Performance summary',
      perfDescription: 'Aggregates latency, cost, and error rate from LLM call logs and usage events.',
      logsTitle: 'Log stream',
      logsDescription: 'Review recent structured service logs with level and keyword filters.',
      empty: 'No data',
      logsLimited: 'Showing the latest {{count}} of {{total}} matching entries.',
      metrics: {
        modelP95: 'Model P95',
        cost: 'Model cost',
        slowest: 'Slowest request',
        modelCount: '{{count}} models',
      },
      filters: {
        level: 'Level',
        allLevels: 'All levels',
        keyword: 'Keyword',
        keywordPlaceholder: 'Search messages or structured fields',
        apply: 'Filter',
      },
      columns: {
        time: 'Time',
        level: 'Level',
        component: 'Component',
        requestId: 'Request ID',
        message: 'Message',
        model: 'Model',
        p95: 'P95',
        avg: 'Average',
        errorRate: 'Error rate',
        cost: 'Cost',
      },
    },
    usage: {
      title: 'Cost and margin dashboard',
      description: 'Review global cost, credit revenue, margin, and quantity through the admin usage endpoints.',
      byService: 'Cost by station',
      byModel: 'Cost by model',
      daily: 'Daily cost trend',
      empty: 'No usage data',
      filters: {
        month: 'Month',
        service: 'Station',
        allServices: 'All stations',
        model: 'Model',
        modelPlaceholder: 'Optional model or model alias',
        start: 'Start',
        end: 'End',
      },
      metrics: {
        cost: 'Cost',
        margin: 'Margin',
        credits: 'Credits',
        quantity: 'Quantity',
        tokens: 'Tokens',
      },
    },
    billing: {
      title: 'Billing console',
      description: 'Manage platform billing through overview, users, details, finance, and wallet operations.',
      empty: 'No billing data',
      unknown: 'Unknown',
      credits: 'Credits',
      exportCsv: 'Export CSV',
      selectUser: 'Select a user to view data',
      serviceShare: 'Station share',
      trendTitle: 'Daily cost, revenue, and margin trend',
      trendDescription: 'Revenue uses 100 Credits = 1 USD for admin reporting.',
      topUsers: 'Top-N users by spend',
      userAnalysis: 'User billing analysis',
      userAnalysisDescription: 'Search users and drill into balance, station, model, project usage, and ledger.',
      userSearchPlaceholder: 'Search username, display name, or user ID',
      byService: 'By station',
      byModel: 'By model',
      byProject: 'Project usage',
      ledger: 'Ledger',
      detailsTitle: 'Platform usage details',
      detailsDescription: 'User, project, station, model, cost, revenue, and margin rows for the current filters.',
      tabs: {
        overview: 'Overview',
        users: 'Users',
        details: 'Usage details',
        finance: 'Finance',
        wallet: 'Top-up and codes',
      },
      filters: {
        month: 'Month',
        start: 'Start',
        end: 'End',
        service: 'Station',
        allServices: 'All stations',
        model: 'Model',
        modelPlaceholder: 'Optional model alias',
        user: 'User',
        userPlaceholder: 'Optional user ID',
        project: 'Project',
        projectPlaceholder: 'Optional project ID',
        includeInternal: 'Include internal accounts',
        includeInternalHint: 'Excluded by default; enable to include admin/test usage (all scope)',
      },
      scope: {
        customer: 'Customer scope',
        customerHint: 'Internal accounts excluded by default',
        allIncluded: 'All scope (includes internal)',
        includesInternalHint: 'Internal accounts included',
      },
      metrics: {
        quantity: 'Total usage',
        events: '{{count}} events',
        cost: 'Total cost USD',
        credits: 'Revenue Credits',
        revenue: 'Revenue USD',
        margin: 'Gross margin USD',
        marginRate: 'Margin rate',
        internalCost: 'Internal usage cost (ops/R&D)',
        internalCredits: 'Internal {{credits}}',
      },
      columns: {
        user: 'User',
        project: 'Project',
        service: 'Station',
      },
      balance: {
        available: 'Available',
        reserved: 'Reserved',
      },
      finance: {
        monthlyCost: 'Monthly cost summary',
        dailyReport: 'Monthly revenue and margin',
        dailyDescription: 'Daily cost, revenue, margin, and margin rate summary.',
        ledgerReport: 'Ledger report',
        ledgerDescription: 'Select a user to show that user ledger.',
      },
      wallet: {
        topUpTitle: 'Top up user',
        topUpDescription: 'Select a user and credit amount. An idempotency key is generated for each submission.',
        amount: 'Amount',
        note: 'Note',
        notePlaceholder: 'Optional audit note',
        topUp: 'Top up',
        topUpSuccess: 'Top-up succeeded. New balance {{balance}}',
        userRequired: 'Enter user ID',
        amountInvalid: 'Amount must be greater than 0',
        codesTitle: 'Generate redemption codes',
        codesDescription: 'Batch generate codes with a fixed amount and optional expiration.',
        count: 'Count',
        purpose: 'Purpose',
        purposes: {
          sale: 'Sale',
          marketing: 'Marketing gift',
          test: 'Test',
          comp: 'Compensation',
        },
        expiresAt: 'Expires at',
        generateCodes: 'Generate codes',
        codesSuccess: 'Generated {{count}} codes',
        copy: 'Copy',
        copySuccess: 'Code copied',
      },
      csv: {
        date: 'Date',
        time: 'Time',
        userId: 'User ID',
        userName: 'User name',
        projectId: 'Project ID',
        service: 'Station',
        model: 'Model',
        unit: 'Usage unit',
        quantity: 'Usage',
        unitCost: 'Unit cost USD',
        cost: 'Internal cost USD',
        credits: 'Charged Credits',
        revenue: 'Credits as USD',
        margin: 'Margin USD',
        marginRate: 'Margin rate',
        count: 'Event count',
        ledgerId: 'Ledger ID',
        type: 'Action type',
        creditDelta: 'Credits delta',
        balanceAfter: 'Balance after',
        refJob: 'Related job',
        note: 'Reference note',
        period: 'Billing period',
        balance: 'Balance',
        available: 'Available',
        reserved: 'Reserved',
      },
      files: {
        usage: 'platform-usage-details',
        daily: 'monthly-revenue-margin',
        ledger: 'credit-ledger',
        statement: 'user-statement',
      },
      ledgerTypes: {
        consume: 'Consumption',
        topup: 'Top-up',
        hold: 'Hold',
        release: 'Release',
        refund: 'Refund',
        adjust: 'Adjustment',
        redeem: 'Redeem',
      },
    },
    models: {
      title: 'Model settings',
      description: 'Model configuration remains on the existing dedicated page. Open /admin/models from here.',
      open: 'Open model settings',
    },
    backup: {
      title: 'SQLite backups',
      description: 'Review core data zip archives, create backups, and stage guarded restores.',
      run: 'Back up now',
      passphraseLabel: 'Backup passphrase',
      passphrasePlaceholder: 'Enter the backup passphrase',
      savePassphrase: 'Save passphrase',
      passphraseSaved: 'Backup passphrase saved',
      passphraseRequired: 'Enter the backup passphrase',
      passphraseStatus: 'Passphrase status: {{status}}',
      passphraseConfigured: 'Set',
      passphraseNotConfigured: 'Not set',
      configSaved: 'Backup settings saved',
      saveConfig: 'Save settings',
      enabled: 'Enabled',
      intervalLabel: 'Backup interval',
      intervalRequired: 'Enter a backup interval',
      coreIntervalPlaceholder: 'e.g. 24h0m0s',
      assetsIntervalPlaceholder: 'e.g. 168h0m0s',
      keepCount: 'Backups to keep',
      keepNPositiveInteger: 'Backups to keep must be a positive integer',
      targetLabel: 'Backup target',
      targetPlaceholder: 'Select a target',
      remoteStatus: '{{type}} remote: {{status}}',
      remoteHealthy: 'Healthy',
      remoteDegraded: 'Degraded',
      remoteNotConfigured: 'Not configured',
      coreTitle: 'Core backup settings',
      coreDescription: 'Back up core database records and metadata.',
      assetsTitle: 'Asset backup settings',
      assetsDescription: 'Back up asset files and media content.',
      assetsObjectStorage: 'Assets are already in object storage',
      assetsLocalDirectory: 'Back up the local asset directory',
      runSuccess: 'Backup created: {{name}}',
      labelPlaceholder: 'Optional label',
      empty: 'No backups yet',
      integrityOk: 'Integrity OK',
      integrityFailed: 'Integrity failed',
      integrityUnknown: 'Integrity unknown',
      download: 'Download',
      restore: 'Restore',
      delete: 'Delete',
      uploadRestore: 'Upload restore',
      deleteSuccess: 'Backup deleted',
      restoreTitle: 'Confirm restore',
      restoreUploadSource: 'Uploaded restore archive',
      restoreWarning: 'This will overwrite all current data. The current database is backed up first, and failed startup restore rolls back automatically.',
      confirmLabel: 'Type RESTORE to confirm',
      confirmPlaceholder: 'Type RESTORE to confirm',
      confirmRestore: 'Confirm restore',
      restoreMissing: 'Select a backup',
      restoreStaged: 'Restore staged. Restart the backend to apply it.',
      restartNow: 'Restart now',
      restartRequested: 'Backend restart requested',
      users: 'Users',
      projects: 'Projects',
      currentStorageBackend: 'Current storage backend: {{backend}}',
      storageBackendUnknown: 'Not configured',
      targets: {
        local: 'Local',
        s3: 'S3',
      },
      columns: {
        name: 'File name',
        time: 'Time',
        size: 'Size',
        integrity: 'Integrity',
        actions: 'Actions',
      },
    },
  },
  adminDashboard: {
    goBack: 'Back to Admin',
    title: 'Operations Dashboard',
    subtitle: 'Read-only ops view from persisted NF data and router state.',
    loadFailed: 'Failed to load dashboard data',
    empty: 'No data',
    unknown: 'Not configured',
    alerts: {
      title: 'Active alerts',
      items: {
        queueDead: {
          title: 'Dead-letter jobs detected',
          detail: 'Queue {{queue}} has {{value}} dead-letter jobs that will not complete on their own.',
        },
        queueBacklog: {
          title: 'Queue backlog exceeds threshold',
          detail: 'Queue {{queue}} has {{value}} ready jobs, exceeding the configured threshold.',
        },
        failureConcentrated: {
          title: 'Dead-letter failures are concentrated',
          detail: 'Reason {{reason}} accounts for {{share}} of {{samples}} samples in queue {{queue}}, indicating a possible systemic fault.',
        },
        ttsPrimaryFailing: {
          title: 'Primary TTS is failing',
          detail: 'The primary failed {{primaryFailures}} times; fallback served {{fallbackServed}} requests.',
        },
      },
    },
    queues: {
      title: 'Gonker queue status',
      description: 'Live ready, leased, and dead-letter counts, tracked separately from generation_jobs.',
      queue: 'Queue',
      ready: 'Ready',
      leased: 'Leased',
      dead: 'Dead',
      failureDominant: 'Dominant failure',
      failureShare: 'Share',
      failureSamples: 'Samples',
      empty: 'No queue data',
    },
    users: {
      title: 'Users',
      total: 'Total users',
      internal: 'Internal',
      admin: 'Admin',
    },
    generation: {
      title: 'Generation Health',
      pending: 'Pending',
      running: 'Running',
      done: 'Done',
      failed: 'Failed',
      partial: 'Partial',
      needsReview: 'Needs review',
      successRate: 'Success rate',
      partialRate: 'Partial rate',
      avgLatency: 'Average chapter latency {{value}} ms',
    },
    llmHealth: {
      title: 'LLM Health',
      openModels: 'Open model settings',
      model: 'Model',
      count: 'Calls',
      successRate: 'Success rate',
      p90Latency: 'P90 latency',
      tps: 'TPS',
      baselineTps: 'Baseline TPS',
      state: 'State',
      degraded: 'Suspect backend degradation, see ai-infra',
      normal: 'Normal',
    },
    roles: {
      title: 'Role routable',
      role: 'Role',
      routable: 'Routable',
    },
    backendHealth: {
      title: 'Backend probes',
      description: 'Aggregate ok/failed/unknown from model_backend_health.',
      ok: 'OK',
      failed: 'Failed',
      unknown: 'Unknown',
      openModels: 'Open model settings',
    },
    storage: {
      title: 'Storage',
      description: 'Backend and bucket configuration.',
      backend: 'Backend',
    },
  },
  modelSettings: {
    title: 'Model settings',
    subtitle: 'Edit backend configuration for every modality. Save sends only changed fields; leaving API Key blank keeps it unchanged.',
    tokenMissingTitle: 'Admin token required',
    tokenMissingDescription: 'Save an admin token on the Admin page before opening model settings.',
    goAdmin: 'Go to Admin',
    backToAdmin: 'Back to admin',
    loadFailed: 'Failed to load model settings',
    defaultBackend: 'Default backend',
    dbOverridden: 'DB override',
    apiKeyStored: 'Key configured',
    dirty: 'Unsaved',
    emptyCategory: 'The backend did not return configuration for this modality.',
    test: 'Test connection',
    discover: 'Discover models',
    testPassed: 'Connection test passed',
    testFailed: 'Connection test failed',
    healthOk: '{{count}} healthy',
    healthFailed: '{{count}} failed',
    healthUnknown: '{{count}} unknown',
    healthDisabled: '{{count}} disabled',
    ttsFallbackStats: 'TTS fallback served {{fallbackServed}} times / primary failed {{primaryFailures}} times',
    ttsFallbackNotConfigured: 'TTS fallback not configured',
    backendDisabled: 'Disabled',
    discoverLoaded: 'Discovered {{count}} models',
    discoverEmpty: 'No models discovered. Enter one manually',
    selectDiscoveredModel: 'Select a discovered model',
    probeUnsupported: 'Probe unsupported',
    probeUnsupportedHint: 'This backend does not support probe endpoint and is not a fault.',
    noChanges: 'No changes to save',
    savedHotReloaded: 'Saved and hot reloaded',
    savedRestart: 'Saved. A restart may be required',
    apiKeyPlaceholder: 'Leave blank to keep unchanged',
    apiKeyHint: 'Blank API Key is not sent; enter a new value to overwrite it.',
    booleanTrue: 'Yes',
    booleanFalse: 'No',
    categories: {
      llm: 'LLM',
      embed: 'Embedding',
      image: 'Image',
      audio: 'Audio',
      asr: 'Speech to text',
      video: 'Video',
      rerank: 'Rerank',
      comfyui: 'ComfyUI',
    },
    categoryDescriptions: {
      llm: 'Text generation providers, editable per backend.',
      embed: 'Embedding provider. CPA backend model name `local/qwen3-embedding-4b` maps to Qwen3-Embedding-4B (2560-dim).',
      image: 'Single backend configuration for image generation.',
      audio: 'Single backend configuration for audio generation.',
      asr: 'Speech-to-text backend for voice input.',
      video: 'Single backend configuration for video workflows.',
      rerank: 'Single rerank backend. CPA alias `bge-reranker-v2-m3` actually points to Qwen3-Reranker-4B (name mismatch, awaiting real alias support in CPA).',
      comfyui: 'Convenience ComfyUI settings with Base URL and model file fields.',
    },
    fields: {
      base_url: 'Base URL',
      endpoint: 'Endpoint',
      provider: 'Provider',
      model: 'Model',
      primary_model: 'Primary Model',
      prompt_suffix: 'Plain-text suffix',
      primary_timeout_sec: 'Primary timeout (s)',
      dim: 'Dimension',
      workflow_template: 'Workflow Template',
      width: 'Width',
      height: 'Height',
      fps: 'FPS',
      duration: 'Duration',
      steps: 'Steps',
      top_n: 'Top N',
      unet_gguf: 'UNet GGUF',
      clip_gguf: 'CLIP GGUF',
      vae: 'VAE',
      cfg: 'CFG',
      seed: 'Seed',
      api_key: 'API Key',
    },
    fieldHints: {
      prompt_suffix: 'Plain-text suffix, such as shared style words; do not enter `<lora:...>` tags',
    },
  },
  storageConfig: {
    title: 'Storage settings',
    subtitle: 'Edit the storage backend and path mapping, then restart the service to apply changes.',
    backToAdmin: 'Back to admin',
    loading: 'Loading storage config…',
    loadFailed: 'Failed to load storage config',
    currentConfig: 'Current config',
    configSummary: 'Database settings override YAML defaults. Leave secret fields blank to keep existing values.',
    credentialTitle: 'Credential note',
    credentialDescription:
      'S3 secrets are submitted only for encrypted server-side storage and are never displayed again. The asset signing key is managed by the server.',
    backend: 'Storage backend',
    s3Title: 'S3 connection',
    bucketsTitle: 'Buckets',
    localRootsTitle: 'Local roots',
    assetSigningKeyConfigured: 'Configured',
    tokenMissingTitle: 'Admin token required',
    tokenMissingDescription: 'Save an admin token on the Admin page before opening this page.',
    goAdmin: 'Go to Admin',
    test: 'Test connection',
    testPassed: 'Connection healthy',
    testFailed: 'Connection failed',
    restartRequired: 'Restart required',
    restartDescription: 'The settings are saved. Restart the admin service so running storage instances use them.',
    resetConfirm: 'Delete the database storage settings and restore the YAML defaults?',
    actions: {
      save: 'Save',
      saving: 'Saving…',
      test: 'Test connection',
      testing: 'Testing…',
      reset: 'Restore defaults',
      resetting: 'Restoring…',
      restart: 'Restart now',
      restarting: 'Restarting…',
    },
    toast: {
      saveSuccess: 'Storage settings saved',
      saveFailed: 'Failed to save storage settings',
      resetSuccess: 'YAML defaults restored',
      resetFailed: 'Failed to restore defaults',
      restartSuccess: 'Restart requested',
      restartFailed: 'Failed to restart the service',
    },
    credentials: {
      accessKey: 'S3 Access Key',
      secretKey: 'S3 Secret Key',
      keepPlaceholder: 'Leave blank to keep unchanged',
      configured: 'Configured',
      notConfigured: 'Not configured',
    },
    fields: {
      backend: 'Storage backend',
      s3Endpoint: 'S3 Endpoint',
      s3Region: 'S3 Region',
      presignTTL: 'Presign TTL (seconds)',
      assetSigningKeyStatus: 'Asset Signing Key status',
    },
    backends: {
      local: 'Local',
      s3: 'S3',
      garage: 'Garage',
    },
    buckets: {
      image: 'image bucket',
      audio: 'audio bucket',
      video: 'video bucket',
      text: 'text bucket',
    },
    local: {
      imageRoot: 'image_root',
      audioRoot: 'audio_root',
      videoRoot: 'video_root',
      textRoot: 'text_root',
    },
    signingKeyConfigured: 'Configured',
    signingKeyRandom: 'Not configured',
  },
  voiceInput: {
    record: 'Record',
    stop: 'Stop {{time}}',
    importAudio: 'Import audio',
    disabledBadge: 'Disabled',
    adminTooltip: 'An admin must configure and test the ASR model',
    preferenceOffTooltip: 'Voice input is turned off',
    preference: 'Voice input',
    tooShort: 'Recording is too short. Please speak a little longer',
    failed: 'Transcription failed. Try again later',
    transcribed: 'Transcription inserted',
    unsupported: 'Recording is not supported in this browser',
    microphoneFailed: 'Could not access the microphone',
    insertModes: {
      append: 'Append',
      replace: 'Replace',
    },
  },
  branch: {
	 fork: 'Fork a new branch',
	 forkChapter: 'Fork from chapter',
	 newName: 'New branch name',
	 forked: 'Branch created',
	 forkFailed: 'Could not create branch',
    title: 'Story branches',
    subtitle: 'Visualize the fork/switch tree of this story. The active branch is marked HEAD; click another node to switch.',
    main: 'Main',
    forkAt: 'fork @ ch.{{value}}',
    empty: 'No branches yet. Fork a branch from a chapter to explore alternate storylines.',
    loadFailed: 'Failed to load branches',
    switched: 'Switched branch',
    switchFailed: 'Failed to switch branch. Try again later.',
    activeBranch: 'Active branch: {{value}}',
    promoteHint: 'Switch to the exploration branch first, then promote it.',
    promote: 'Promote',
    promoted: 'Branch promoted to the new main line',
    promoteFailed: 'Failed to promote branch. Try again later.',
    promoteConfirmTitle: 'Promote to new main',
    promoteConfirmDescription: 'Promote "{{name}}" to main and archive the old main.',
    promoteIrreversible: 'This is a high-risk data migration. The old main will be archived as archived-* and this cannot be undone.',
    promoteConfirmAction: 'Confirm promote',
  },
  onboarding: {
    title: 'First Film Checklist',
    description: 'Run the smallest three-step path from project setup to the first rendered video.',
    loadFailed: 'Failed to load onboarding status. Try again later.',
    status: {
      done: 'Done',
      current: 'Current',
      todo: 'To do',
    },
    steps: {
      project: {
        title: 'Create a project and confirm the skeleton',
        description: 'Create the story container and confirm it can hold chapters and production assets.',
        action: 'Open projects',
      },
      chapter: {
        title: 'Generate one chapter plus screenplay/storyboard',
        description: 'Finish one chapter and produce its screenplay and storyboard assets.',
        action: 'Open chapter',
      },
      film: {
        title: 'Compose the first film',
        description: 'Open the video station and compose the available materials into a first finished video.',
        action: 'Open compose',
      },
    },
  },
  project: {
    title: 'Projects',
    subtitle: 'Manage story projects, chapter scaffolds, and generation modality preferences',
    new: 'New project',
    selectProject: 'Select project',
    searchProject: 'Search project titles',
    noProjectResults: 'No matching projects',
    recentProjects: 'Recent',
    allProjects: 'All projects',
    allProjectsAggregate: 'All projects',
    name: 'Project title',
    titleRequired: 'Enter a project title',
    titleTooLong: 'Project title must be at most 120 characters',
    description: 'Description',
    descriptionTooLong: 'Description must be at most 800 characters',
    genre: 'Genre',
    genreTooLong: 'Genre must be at most 80 characters',
    status: 'Status',
    words: 'Words',
    wordsGenerated: 'Generated',
    wordsTarget: 'Target',
    wordsUnit: 'words',
    sort: {
      label: 'Project sort',
      updated: 'Recently updated',
      title: 'Title',
      words: 'Words',
      chapters: 'Chapter count',
    },
    targetWords: 'Target words',
    targetWordsPositive: 'Target words must be greater than 0',
    chapters: 'Chapters',
    empty: 'No projects yet',
    emptyHint: 'Create a story project to open its chapter tree, content workspace, and settings panels.',
    createDescription: 'Create the project container first. Later stages will add the chapter tree and text generation loop.',
    creating: 'Creating',
    validationFailed: 'Check the project form',
    backToProjects: 'Back to projects',
    created: 'Project created',
    saved: 'Project saved',
    delete: 'Delete project',
    moveToTrash: 'Move to trash',
    deleteMoved: 'Project moved to trash',
    deleteFailed: 'Failed to delete project. Try again later.',
    deleteConfirmTitle: 'Move to trash',
    deleteConfirmDescription: '"{{title}}" will be moved to trash and can be restored within 7 days.',
    noDescription: 'No description yet',
    unknown: 'Not set',
    chapterCount: '{{value}} chapters',
    wordsValue: '{{value}} words',
    modalitiesTitle: 'Generation modalities',
    modalities: {
      screenplay: 'Screenplay',
      audio: 'Audio',
      image: 'Image',
      video: 'Video',
    },
    modalitiesText: 'Text',
    modalitiesSaved: 'Generation modalities saved',
    modalitiesSaveFailed: 'Failed to save generation modalities. Try again later.',
    titleSaveFailed: 'Failed to save the project title. Try again later.',
    generateNow: 'Generate chapter now',
    trash: {
      title: 'Trash',
      subtitle: 'Deleted projects are kept for 7 days. Expired projects are purged automatically when trash opens.',
      deletedAt: 'Deleted at',
      remainingDays: 'Remaining',
      remainingDaysValue: '{{count}} days',
      actions: 'Actions',
      restore: 'Restore',
      restoreSuccess: 'Project restored',
      restoreFailed: 'Failed to restore project. Try again later.',
      purge: 'Delete permanently',
      purgeSuccess: 'Project permanently deleted',
      purgeFailed: 'Failed to permanently delete project. Try again later.',
      purgeConfirmTitle: 'Delete project permanently',
      purgeConfirmDescription: '"{{title}}" will be permanently deleted. Usage events are retained for audit; other project data cannot be restored.',
      empty: 'Trash is empty',
      emptyHint: 'Projects moved to trash appear here and can be restored within 7 days.',
      searchPlaceholder: 'Search trashed projects…',
      noMatch: 'No matching trashed projects',
    },
    wizard: {
      modeLabel: 'Creation mode',
      easyMode: 'Easy',
      advancedMode: 'Advanced',
      description: 'Build the project definition in story-causal order. Only genre and target words are required; everything else can grow later.',
      easy: {
        description: 'Start with the spark of a story. AI will shape it into an editable project draft.',
        ideaLabel: 'What do you want to write?',
        ideaPlaceholder: 'Example: An amnesiac postman receives a letter addressed to someone who will die tomorrow.',
        ideaRequired: 'Tell us what you want to write first',
        lengthLabel: 'Length',
        start: 'Start creating',
        drafting: 'Shaping your story',
        summaryTitle: 'What AI worked out for you',
        fallbackHint: 'Only genre directions were available this time. Choose one to create the project and fill in the rest later.',
        chooseGenre: 'Choose a genre',
        createProject: 'Create project',
        advanced: 'Advanced settings',
        groups: {
          basic: 'Basics',
          world: 'World',
          protagonist: 'Protagonist',
          antagonist: 'Antagonist',
        },
      },
      autopilot: {
        title: 'Autopilot writing',
        targetWords: 'Target words',
        chapterWords: 'Words per chapter',
        enable: 'Write the first volume automatically after creation',
        enableHint: 'Off by default. When enabled, the system plans and confirms the outline before writing chapters.',
        estimating: 'Calculating size and credits',
        estimateUnavailable: 'Enter target words, chapter size, and genre to see the estimate.',
        layout: '{{chapters}} chapters · {{volumes}} volumes',
        firstVolume: 'First volume: {{chapters}} chapters · about {{words}} words',
        credits: 'Estimated {{low}}–{{high}} credits',
        checkpoints: 'Stops after chapters 1 / 2 / 3 and chapter {{end}} for review',
        retry: 'Retry current step',
        failedStage: '{{stage}} failed. The created project is kept; retry this step.',
        stages: {
          create_project: 'Creating project…',
          propose_skeleton: 'Generating volume skeleton…',
          confirm_skeleton: 'Generating chapter outlines…',
          confirm_outlines: 'Confirming outlines…',
          start_autopilot: 'Starting Autopilot…',
        },
        stageNames: {
          create_project: 'Project creation',
          propose_skeleton: 'Skeleton generation',
          confirm_skeleton: 'Chapter outline generation',
          confirm_outlines: 'Confirm outlines',
          start_autopilot: 'Autopilot start',
        },
      },
      coreTheme: 'Core theme',
      coreThemeHint: 'The question or belief the book keeps testing. Leave it blank if it has not emerged yet.',
      coreThemePlaceholder: 'Example: after gaining power, can someone still keep their first kindness?',
      aiCoreTheme: 'AI refine theme',
      contentType: 'Content type',
      lengthForm: 'Length / form',
      contentLanguage: 'Manuscript language',
      contentLanguageHint: 'The language the AI writes skeletons and chapters in — independent of the interface language, and overridable per chapter after creation.',
      cascadeThreshold: 'Auto-cascade threshold',
      cascadeStopAt: 'Auto-cascade stop point',
      cascadeCostTitle: 'Cost estimate',
      cascadeCostEstimate: 'Auto-cascading through {{station}} is estimated to use about {{tokens}} tokens.',
      cascadeSaveFailed: 'Project created, but the cascade policy failed to save. You can complete it on the project details page.',
      worldSaveFailed: 'Project created, but world settings failed to save. You can complete them on the project details page.',
      cascadeThresholds: {
        passed_only: 'Only passed auto-runs',
        review_ok: 'Review-needed also auto-runs',
        manual: 'Fully manual',
      },
      contentTypes: {
        fiction: 'Fiction',
        nonfiction: 'Nonfiction (future)',
      },
      lengthForms: {
        poetry: 'Poetry (future)',
        short: 'Short',
        medium: 'Novella (future)',
        long: 'Long-form',
      },
      axisHint: 'Fiction supports short and long forms. Nonfiction, poetry, and other forms remain reserved.',
      genrePlaceholder: 'Select a primary genre',
      secondaryDrivers: 'Secondary drivers',
      secondaryDriversPlaceholder: 'Choose what moves the story',
      selectedDriverCount: '{{count}} drivers selected',
      fallbackTitle: '{{label}} Project',
      untitledProject: 'Untitled project',
      driverSearch: 'Search drivers',
      driverEmpty: 'No matching driver',
      recommended: 'Suggested',
      removeDriver: 'Remove driver',
      logline: 'Logline',
      loglineHint: 'One sentence with protagonist, goal, resistance, and the distinct hook.',
      loglinePlaceholder: 'When a protagonist at a low point gains an unusual chance, they must reach the goal before the cost arrives.',
      aiLogline: 'AI refine logline',
      worldRules: 'World rules',
      titlePlaceholder: 'Optional. Generated from genre or logline if blank',
      descriptionPlaceholder: 'Selling point, image, opening thought, or any temporary idea',
      protagonistName: 'Protagonist name',
      protagonistNameEn: 'Protagonist English name',
      protagonistMotivation: 'Protagonist motivation',
      protagonistInnerFlaw: 'Inner flaw / gap',
      protagonistIdentity: 'Identity / starting situation',
      antagonistSource: 'Antagonist source',
      toneKeynote: 'Tone keynote',
      perspectivePlaceholder: 'Example: limited third person / first-person memoir',
      aiFailed: 'Failed to generate AI suggestions. Try again later.',
      aiSuggestions: 'AI suggestions',
      aiLlmSource: 'Multi-angle suggestions from the local model. You can keep editing after applying one.',
      aiFallbackSource: 'Template fallback suggestions. You can keep editing after applying one.',
      useSuggestion: 'Use',
      discardSuggestions: 'Discard',
      validation: {
        genreRequired: 'Select a primary genre',
        coreThemeTooLong: 'Core theme must be at most 500 characters',
        loglineTooLong: 'Logline must be at most 600 characters',
        antagonistTooLong: 'Antagonist source must be at most 300 characters',
        toneTooLong: 'Tone keynote must be at most 200 characters',
        perspectiveTooLong: 'Narrative perspective must be at most 120 characters',
      },
    },
  },
  novelImport: {
    importNovel: 'Import novel',
    kicker: 'Manuscript import',
    title: 'Import novel',
    subtitle: 'Upload txt/md/fdx/fountain or paste manuscript text, preview chapter splitting, then create the project and chapters.',
    sourceTitle: 'Upload or paste',
    sourceDescription: 'Plain text, Markdown, Final Draft FDX, and Fountain are supported. Preview does not create a project.',
    upload: 'Upload file',
    uploadHint: 'Supports .txt / .md / .fdx / .fountain, or paste the manuscript directly',
    limitHint: 'Supports .txt/.md/.fdx/.fountain, up to about 5 million characters / 15MB. GBK and UTF-8 are detected automatically.',
    encodingLabel: 'Encoding: {{encoding}}',
    encodingConverted: 'GBK/GB2312 encoding detected and converted automatically',
    textLabel: 'Manuscript text',
    textPlaceholder: 'Paste the full novel text, or upload a txt/md file and edit it here.',
    textStats: '{{count}} characters entered',
    nearLimitHint: 'Approaching limit',
    overLimitHint: 'Over the 5 million character limit',
    metaTitle: 'Project info',
    metaDescription: 'These fields are used to create the new project on confirmation.',
    titlePlaceholder: 'Example: Ember Under Long Night',
    genrePlaceholder: 'Choose a template genre or enter a custom genre',
    advancedTitle: 'Chapter splitting',
    advancedDescription: 'After changing regex or Markdown heading detection, preview again to resplit.',
    customRegex: 'Custom split regex',
    customRegexPlaceholder: 'Example: ^Chapter\\s+\\d+',
    allowMarkdownHeading: 'Detect Markdown headings',
    preview: 'Preview',
    confirm: 'Confirm import',
    previewTitle: 'Chapter preview',
    previewDescription: 'Check the chapter count, titles, and content snippets before importing.',
    chapterCount: '{{count}} chapters',
    strategy: 'Strategy: {{value}}',
    strategyBuiltin: 'Smart chapter-title splitting',
    strategyCustom: 'Custom chapter splitting rule',
    advancedPreview: 'Advanced',
    regex: 'Raw splitting rule: {{value}}',
    chapterLine: 'Chapter {{index}}: {{title}}',
    wordCount: '{{count}} words',
    expandHint: 'Expand / collapse',
    screenplay: {
      title: 'Screenplay structure',
      description: 'This import contains script scenes, character dialogue, and action blocks from {{format}}.',
      scene: 'Scene',
      sceneCount: '{{count}} scenes',
      dialogueCount: '{{count}} dialogue lines',
      characters: 'Characters',
      chapterStats: '{{scenes}} scenes / {{dialogues}} dialogue lines',
      unknownSetting: 'Unnamed setting',
    },
    emptyPreview: 'No preview yet',
    emptyPreviewHint: 'Enter text and preview to see the chapter split result.',
    imported: 'Import succeeded with {{count}} chapters',
    errors: {
      emptyText: 'Upload a file or paste manuscript text first',
      readFile: 'Failed to read the file. Try again.',
      noChapters: 'No chapters recognized. Try a custom regex.',
      tooLarge: 'Content is too large',
      fileTooLarge: 'File is too large (>15MB). Import it in volumes.',
      textTooLarge: 'Text exceeds the 5 million character limit. Import it in volumes.',
      generic: 'Import failed. Try again later.',
    },
  },
  detail: {
    author: 'Author',
    settingsMode: 'Settings mode',
    settingsEasy: 'Easy',
    settingsAdvanced: 'Advanced',
    worldExtras: 'Extra setting (era / place / atmosphere)',
    loadFailed: 'Project failed to load',
    chaptersTab: 'Chapters',
    skeletonTab: 'Planning',
    gameplayTab: 'Gameplay',
    productionPipelineTab: 'Production pipeline',
    ingestReviewTab: 'Entity review',
    assetLibraryTab: 'Asset library',
    storylinesTab: 'Storylines',
    storyStateTab: 'Story state',
    characterStatesTab: 'Character states',
    relationGraphTab: 'Relation graph',
    chapterTree: 'Chapter tree',
    chapterTreeHint: 'Quickly locate and manage chapters by volume',
    chapterNode: 'Chapter {{value}}',
    chapterEmpty: 'No chapters yet. Planning produces per-chapter outlines; nodes appear once a chapter is written — use “New chapter” above to start, and the planned outline is filled in for you.',
    contentWorkspace: 'Content workspace',
    contentWorkspaceHint: 'Read, generate, and revise selected chapter content here',
    overview: 'Overview',
    reader: 'Reader',
    pipeline: 'Pulse',
    outlineMode: 'Outline mode',
    narrativePerspective: 'Narrative perspective',
    contentPlaceholderTitle: 'Content shell is ready',
    contentPlaceholderBody: 'Select a chapter to view text, generation state, and rewrite results.',
    readerPlaceholder: 'Select a chapter to use immersive reading and display controls.',
    pipelinePlaceholder: 'Chapter station states are summarized in the pulse board.',
    settingsRoles: 'Settings / Roles',
    settingsRolesHint: 'Structured setting cards and character assets are managed here',
    worldSettings: 'World settings',
    projectDefinition: 'Project definition',
    timePeriod: 'Time period',
    location: 'Location',
    atmosphere: 'Atmosphere',
    worldRules: 'World rules',
    savingSettings: 'Saving',
    settingsSaved: 'Settings saved',
    settingsSaveFailed: 'Failed to save settings. Try again later.',
    rolesPlaceholder: 'Character cards, world rules, and asset entry points are collected here.',
    cascadePolicy: {
      simpleTitle: 'Generate through',
      presets: { text: 'Text only', storyboard: 'Through storyboard', pages: 'Through panel art' },
      customPreset: 'A custom policy is active. Choosing a preset updates both approval and endpoint.',
      pagesHint: 'Generates panel images automatically; assemble finished pages manually at the page station.',
      simpleStop: 'Stop and ask me',
      simpleAuto: 'Keep going',
      simpleUntil: 'Continue through',
      simpleStopHint: 'Every station stops after producing its output; you decide when to advance.',
      title: 'Generation cascade policy',
      description: 'Choose which quality-gate result continues automatically and where the pipeline stops.',
      saved: 'Cascade policy saved',
      saveFailed: 'Failed to save the cascade policy. Try again later.',
    },
    softConsistency: {
      title: 'Soft consistency feedback',
      master: 'Soft consistency feedback',
      masterHint: 'Controls whether soft consistency checks are enabled for this project.',
      ooc: 'Character drift',
      oocHint: 'Flags subtle drift in character behavior, voice, or ability boundaries.',
      setting: 'Setting consistency',
      settingHint: 'Flags soft drift in worldbuilding, rules, and facts.',
      emotion: 'Emotional continuity',
      emotionHint: 'Flags issues in character emotion arcs and scene-to-scene emotional handoff.',
      experimental: 'Experimental',
      globallyDisabled: 'Soft consistency feedback is not enabled in deployment config. Project controls are unavailable.',
      loadFailed: 'Failed to load soft consistency feedback settings.',
      saved: 'Soft consistency feedback settings saved',
      saveFailed: 'Failed to save soft consistency feedback settings. Try again later.',
    },
    projectSkills: {
      title: 'Project skills',
      empty: 'No skills are available for this project.',
      loadFailed: 'Failed to load project skill settings.',
      saved: 'Project skill setting saved',
      saveFailed: 'Failed to save project skill setting. Try again later.',
    },
    pipelineViewer: {
		chapter: 'Chapter',
      title: 'Production pipeline',
      subtitle: 'Chapter {{chapter}} · {{title}}',
      selectChapter: 'Select a chapter in the chapter tree to inspect screenplay, storyboard, images, audio, and video assets.',
      notGenerated: 'Not generated',
      loadFailed: 'Failed to load asset',
      regenerate: 'Regenerate',
      openWorkbench: 'Open workbench',
      queued: 'Queued',
      regenerateFailed: 'Regeneration failed. Try again later.',
      noCharacterTarget: 'This project has no character available for design generation',
      cascadePolicy: {
        title: 'Auto-cascade stop point',
        scope: 'Project-level setting',
        description: 'Controls which station this project auto-cascades to after chapter text passes. Text stops before downstream stations.',
        costTitle: 'Cost estimate',
        costEstimate: 'Auto-cascading through {{station}} is estimated to use about {{tokens}} tokens.',
        saved: 'Auto-cascade stop point saved',
        saveFailed: 'Failed to save auto-cascade stop point. Try again later.',
      },
      compose: {
		missing: 'Required before composing: {{items}}',
        submit: 'Compose video',
        done: 'Video composed',
        failed: 'Video composition failed. Try again later.',
        aspectLandscape: '16:9',
        aspectPortrait: '9:16',
        bgmNone: 'No BGM',
      },
      credits: {
        insufficient: 'Insufficient balance. Top up or redeem Credits before generation.',
        topUp: 'Top up',
        videoConfirmTitle: 'Confirm video generation',
        videoConfirmDescription: '{{credits}}. Video generation has high cost; consumed Credits are not refundable after confirmation.',
        videoConfirmSubmit: 'Confirm and generate',
      },
      sceneFallback: 'Scene {{index}}',
      unknownSpeaker: 'Unknown character',
      panelNo: 'Panel {{index}}',
      panelImageAlt: 'Storyboard panel {{index}} image',
      poolGallery: {
        zoom: 'View full size',
        replay: 'Reproduce candidate',
        replayWaiting: 'No reproduction result yet. Check the job board or refresh later.',
        seed: 'Seed {{seed}}',
        styles: { manga: 'Manga', anime: 'Anime', watercolor: 'Watercolor', realistic: 'Realistic', ink_wash: 'Ink wash', comic: 'Comic' },
        title: 'Candidate pool',
        count: '{{count}} images',
        primary: 'Primary',
        score: 'Score {{score}}',
        useAsPrimary: 'Use as primary',
        selected: 'Primary image updated',
        selectFailed: 'Failed to update primary image. Try again later.',
        selectCandidate: 'Select candidate image ranked {{rank}}',
        candidateAlt: 'Candidate image #{{rank}}',
      },
      shotType: 'Shot',
      composition: 'Composition',
      dialogueBubbles: 'Bubbles',
      narrationBox: 'Narration',
      chapterImageAlt: 'Chapter image',
      characterDesignAlt: '{{name}} character design image',
      designNotReady: 'No character design yet',
      designGenerating: 'Generating character design',
      generateDesign: 'Generate design',
      designViews: {
        front: 'Front',
        side: 'Side',
        back: 'Back',
      },
      mediaUnsupported: 'Your browser does not support this media playback.',
      status: {
        pending: 'Pending',
        running: 'Running',
        done: 'Done',
        needs_review: 'Needs review',
        failed: 'Failed',
      },
      audioWorkbench: {
        narratorVoice: 'Narrator voice',
        characterVoices: 'Character voices',
        speechRate: 'Speech rate',
        configDefault: 'Use global config',
        customVoicePlaceholder: 'Custom voice id',
      },
      stations: {
        screenplay: {
          title: 'Screenplay',
          description: 'Review scenes with narration, action, and dialogue.',
        },
        storyboard: {
          title: 'Storyboard',
          description: 'Inspect panel shots, composition notes, and rendered frames.',
        },
        panel_image: {
          title: 'Chapter images',
          description: 'Browse generated raw chapter image assets.',
        },
        character_design: {
          title: 'Character designs',
          description: 'Show generated character turnaround or design images.',
        },
        audio: {
          title: 'Audio',
          description: 'Play the synthesized chapter narration and dialogue.',
        },
        video: {
          title: 'Video',
          description: 'Play the chapter video assembled from panels and audio.',
        },
      },
      sketchReview: {
        loadFailed: 'Failed to load sketch review',
        updateFailed: 'Failed to update sketch',
        confirmFailed: 'Failed to confirm sketches',
        rendered: 'Sketch generated',
      },
    },
  },
  workbench: {
	 pipelineHint: 'View assets and generation status in the production pipeline.',
	 openPipeline: 'Open production pipeline',
    backToProject: 'Back to project',
    chapterLabel: 'Chapter {{number}} · {{title}}',
    chapterUnavailable: 'Chapter info unavailable',
    versionCurrent: 'Current version',
    configJson: 'JSON config',
    saveConfig: 'Save config',
    loadFailed: 'Workbench failed to load',
    resolvedConfig: 'Resolved config',
    configDefault: 'Use config default',
    scope: {
      project: 'Project default',
      chapter: 'Chapter override',
    },
    toast: {
      saved: 'Workbench config saved',
      saveFailed: 'Failed to save workbench config',
    },
    screenplay: {
      style: 'Style',
      customStylePlaceholder: 'Enter custom style',
      length: 'Length',
      dialogueDensity: 'Dialogue density',
      pov: 'Point of view',
    },
    storyboard: {
      shotDensity: 'Shot density',
      preferredShotTypes: 'Preferred shot types',
      cameraLanguage: 'Camera language',
      customCameraLanguagePlaceholder: 'Enter custom camera language',
      styleLock: 'Style lock',
      customStyleLockPlaceholder: 'Enter style lock description',
      sketchReviewEnabled: 'Enable sketch review',
    },
    panelImage: {
      model: 'Model',
      size: 'Size',
      seedStrategy: 'Seed strategy',
      seedDeterministic: 'Deterministic',
      seedFixed: 'Fixed value',
      seedPlaceholder: 'Enter integer seed',
      stylePreset: 'Style preset',
      styleLockArtStyle: 'Style lock: art style',
      styleLockArtStylePlaceholder: 'e.g. cinematic anime, Zima Blue aesthetic',
      styleLockPalette: 'Style lock: palette',
      styleLockPalettePlaceholder: 'e.g. cold deep blue, high contrast',
      styleLockQuality: 'Style lock: quality',
      styleLockQualityPlaceholder: 'e.g. masterpiece, best quality, 8k',
      styleLockNegative: 'Style lock: negative',
      styleLockNegativePlaceholder: 'e.g. low quality, extra fingers',
      configDefault: 'Use config default',
    },
    preview: {
      title: 'Preview',
      subtitle: 'Station rendering wiring is reserved for later phases',
      placeholder: 'Preview placeholder',
    },
    versions: {
      title: 'Versions',
      subtitle: 'Version history wiring is reserved for later phases',
      placeholder: 'Version history placeholder',
    },
    stations: {
      chapter_text: 'Text workbench',
      screenplay: 'Screenplay workbench',
      storyboard: 'Storyboard workbench',
      panel_image: 'Image workbench',
      audio: 'Audio workbench',
      video: 'Video workbench',
    },
  },
  sketchReview: {
    title: 'Sketch review',
    subtitle: 'Structured sketch frames from storyboard spatial intent, without image generation.',
    empty: 'No sketch frames',
    panelNo: 'Panel {{index}}',
    confirmAll: 'Confirm all',
    renderSketch: 'Generate sketch',
    rerenderPanel: 'Re-render panel',
    thumbnailPending: 'Sketch not generated',
    thumbnailAlt: 'Rendered sketch thumbnail',
    vlmTitle: 'VLM check',
    vlmScore: 'VLM {{score}}',
    vlmIssueFallback: 'Composition check failed',
    pool: {
      title: 'Sketch candidates',
      count: '{{count}} images',
      primary: 'Primary sketch',
      score: '{{score}} pts',
      useAsPrimary: 'Use as primary',
      selectCandidate: 'Select sketch candidate {{rank}}',
      candidateAlt: 'Sketch candidate {{rank}}',
    },
    slot: 'Slot',
    depth: 'Depth',
    gaze: 'Gaze',
    posture: 'Posture',
    status: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      modified: 'Modified',
    },
  },
  gameplay: {
    advancedMode: 'Advanced mode',
    saving: 'Saving',
    unset: 'Unset',
    weightHint: 'This dimension\'s emphasis weight in the overall gameplay configuration (0-100%). A higher value means the book foregrounds this dimension more; it guides generation priorities.',
    profile: {
      title: 'Gameplay profile',
      description: 'Basic mode shows the five-dimension overview; advanced mode tunes global target weights.',
      templatePlaceholder: 'Choose template',
      coreLoopDesc: 'Core loop',
      readerAppetite: 'Reader appetite',
      empty: 'This project has no gameplay profile yet. Choose a template to create one.',
      reset: 'Reset',
      saved: 'Gameplay profile saved',
      saveFailed: 'Failed to save gameplay profile. Try again later.',
    },
    chapter: {
      title: 'Chapter target tuning',
      subtitle: 'Chapter {{chapter}} · {{title}}',
      selectChapter: 'Select a chapter in the chapter tree before tuning its gameplay target.',
      saveTarget: 'Save target',
      saved: 'Chapter gameplay target saved',
      saveFailed: 'Failed to save chapter gameplay target. Try again later.',
      pendingState: 'Saving returns this chapter to pending until the next observation refresh.',
      status: 'Current status: {{status}}',
    },
    dimensions: {
      coreLoop: {
        label: 'Core loop',
        hint: 'The recurring satisfaction pattern that drives readers through the story, such as domination, upgrade faceslap, or infinite runs. It defines the book\'s main payoff engine.',
      },
      agency: {
        label: 'Agency axis',
        hint: 'How much control the protagonist has over the situation: dominant means the protagonist overwhelms opponents, reactive means events push them around, and proactive means they attack and plan ahead.',
      },
      info: {
        label: 'Information gap',
        hint: 'The knowledge gap between readers and characters that creates tension: open information keeps both sides aligned, hidden truth keeps readers in the dark, and dramatic irony lets readers know first.',
      },
      social: {
        label: 'Social frame',
        hint: 'The relationship framework or reference group around the protagonist, such as sect, solo, or family. It shapes character interaction and sources of conflict.',
      },
      reward: {
        label: 'Reward structure',
        hint: 'The rhythm for delivering payoffs and rewards: immediate gives satisfaction right away, while delayed satisfaction sets up a later burst. It shapes reader follow-through.',
      },
    },
    trajectory: {
      title: 'Live arc preview',
      description: 'Pure SVG curve for cross-chapter target, observed, and score data.',
      empty: 'No gameplay trajectory yet.',
      loadFailed: 'Failed to load gameplay trajectory.',
      series: {
        target_core: 'Target core',
        observed_core: 'Observed core',
        target_payoff: 'Target payoff',
        observed_payoff: 'Observed payoff',
        score: 'Score',
      },
    },
    values: {
      upgrade_faceslap: 'Upgrade faceslap',
      sign_in: 'Sign-in rewards',
      mystery: 'Mystery',
      farming: 'Farming / management',
      scheme: 'Scheming',
      domination: 'Domination',
      infinite: 'Infinite run',
      rebirth_revenge: 'Rebirth revenge',
      hidden_dev: 'Hidden development',
      survival: 'Survival pressure',
      reactive: 'Reactive',
      proactive: 'Proactive',
      dominant: 'Dominant',
      hidden: 'Hidden',
      open: 'Open information',
      dramatic_irony: 'Dramatic irony',
      hidden_truth: 'Hidden truth',
      solo: 'Solo',
      sect: 'Sect',
      court: 'Court',
      city: 'City',
      team: 'Team',
      immediate: 'Immediate',
      delayed: 'Delayed',
      layered: 'Layered',
      cliff: 'Cliff',
    },
    valueHints: {
      upgrade_faceslap: 'The protagonist keeps growing stronger and strikes back at those who underestimated them.',
      sign_in: 'Recurring check-ins or periodic rewards provide steady resources and growth.',
      mystery: 'Unanswered questions drive exploration through clues, reveals, and investigation.',
      farming: 'Low-conflict progression focused on management, development, and accumulated gains.',
      scheme: 'Strategy and calculation move the plot through planning, leverage, and mind games.',
      domination: 'The protagonist overwhelms opponents with superior power, emphasizing control and payoff.',
      infinite: 'The protagonist survives repeated scenarios, instances, or worlds with changing rules.',
      rebirth_revenge: 'The protagonist is reborn with memories, seeking revenge and changing fate.',
      hidden_dev: 'The protagonist grows quietly while hiding strength, then erupts at the right moment.',
      survival: 'High-pressure survival with scarce resources and persistent danger.',
      reactive: 'Characters are pushed by events and respond to external pressure or sudden changes.',
      proactive: 'Characters set goals and drive action, creating a more assertive pace.',
      dominant: 'Characters control choices and the situation, emphasizing command and pressure.',
      hidden: 'Key information or plans stay concealed until later reveals create reversals.',
      open: 'Important information is visible, so conflict comes from choices, positions, and action.',
      dramatic_irony: 'Readers know something characters do not, creating tension through knowledge gaps.',
      hidden_truth: 'The truth is obscured, and the plot advances by moving closer to it.',
      solo: 'Focuses on individual action and personal growth with limited collaboration.',
      sect: 'Uses sects, clans, or organization ranks as the social reference frame.',
      court: 'Uses court politics and power structures to drive alliances and authority shifts.',
      city: 'Uses urban networks, local factions, and public incidents as the social frame.',
      team: 'Moves through team collaboration, roles, bonds, and tactics.',
      immediate: 'Rewards pay off quickly for short-cycle satisfaction and fast feedback.',
      delayed: 'Rewards arrive later, using anticipation and setup to increase payoff.',
      layered: 'Rewards pay off in layers, creating chained upgrades and repeated satisfaction.',
      cliff: 'Rewards or crises stop at a hook, pushing the reader into the next beat.',
    },
  },
  acts: {
    title: 'Act structure',
    subtitle: 'Manually maintain act boundaries and the act 2 midpoint.',
    persisted: 'Saved',
    default: 'Default',
    loadFailed: 'Act structure failed to load',
    empty: 'No editable act structure for this project.',
    actLabel: 'Act {{act}}',
    save: 'Save acts',
    fields: {
      start: 'Start chapter',
      end: 'End chapter',
      midpoint: 'Midpoint',
      enabled: 'Enabled',
    },
    roles: {
      setup: 'Setup',
      confrontation: 'Confrontation',
      resolution: 'Resolution',
    },
    messages: {
      saved: 'Act structure saved',
      saveFailed: 'Failed to save act structure',
    },
  },
  storylines: {
    title: 'Storylines',
    subtitle: 'Manage long-running lines, subplot promises, and chapter-level emphasis.',
    newStoryline: 'New line',
    newSubplot: 'New subplot',
    loadFailed: 'Storylines failed to load',
    empty: 'No storylines yet.',
    noSubplots: 'No subplots in this line.',
    priority: 'P{{priority}}',
    weightsTitle: 'Chapter {{chapter}} weights',
    convergenceNode: 'Convergence',
    saveWeights: 'Save weights',
    createStoryline: 'Create storyline',
    editStoryline: 'Edit storyline',
    createSubplot: 'Create subplot',
    editSubplot: 'Edit subplot',
    deleteStoryline: 'Delete storyline',
    deleteSubplot: 'Delete subplot',
    fillSubplot: 'Move to filling',
    detonateSubplot: 'Detonate',
    confirmDeleteStoryline: 'Delete storyline "{{name}}"?',
    confirmDeleteSubplot: 'Delete subplot "{{title}}"?',
    storylineDialogDescription: 'Define the durable line this project should track.',
    subplotDialogDescription: 'Define a setup, target payoff, and convergence point.',
    subplotMeta: 'Dig {{dig}} · Target {{target}} · Converge {{convergence}}',
    fields: {
      name: 'Name',
      name_en: 'English name',
      lineType: 'Line type',
      priority: 'Priority',
      status: 'Status',
      arcSummary: 'Arc summary',
      storyline: 'Storyline',
      title: 'Title',
      description: 'Description',
      digChapter: 'Dig chapter',
      targetChapter: 'Target chapter',
      convergenceChapter: 'Convergence chapter',
      importance: 'Importance',
      remindBefore: 'Remind before',
      includeInContext: 'Include in context',
    },
    lineTypes: {
      main: 'Main',
      romance: 'Romance',
      power: 'Power',
      mystery: 'Mystery',
      politics: 'Politics',
    },
    status: {
      active: 'Active',
      dormant: 'Dormant',
      closed: 'Closed',
    },
    subplotStatus: {
      dug: 'Dug',
      filling: 'Filling',
      detonated: 'Detonated',
    },
    messages: {
      storylineCreated: 'Storyline created',
      storylineUpdated: 'Storyline saved',
      storylineDeleted: 'Storyline deleted',
      subplotCreated: 'Subplot created',
      subplotUpdated: 'Subplot saved',
      subplotDeleted: 'Subplot deleted',
      subplotFilling: 'Subplot moved to filling',
      subplotDetonated: 'Subplot detonated',
      weightsSaved: 'Weights saved',
      saveFailed: 'Failed to save. Try again later.',
      deleteFailed: 'Failed to delete. Try again later.',
      transitionFailed: 'Status transition failed.',
      weightsFailed: 'Failed to save weights.',
    },
  },
  storyState: {
    title: 'Story state',
    subtitle: 'Read-only debt view for overdue payoffs, subplot promises, convergence, and volume budget.',
    chapter: 'Chapter',
    loadFailed: 'Story state failed to load',
    debtTotal: 'Open debt',
    convergenceDensity: 'Convergence density',
    currentPosition: 'Current position',
    positionValue: 'Chapter {{chapter}} · Volume {{volume}}',
    wordBudgetValue: '{{current}} / {{total}} chapters · {{words}} words',
    contextDigest: 'Context digest',
    overdueForeshadows: 'Overdue foreshadows',
    overdueSubplots: 'Overdue subplots',
    noForeshadows: 'No overdue foreshadows.',
    noSubplots: 'No overdue subplots.',
    trendTitle: 'Trend',
    trendFrom: 'From chapter',
    trendTo: 'To chapter',
    trendInvalidRange: 'Enter a valid chapter range up to 1000 chapters.',
    trendLoadFailed: 'Trend failed to load',
    recallRate: 'Recall rate',
    subplotDensity: 'Subplot density',
    resolved: 'Resolved',
    overdue: 'Overdue',
  },
  character: {
    title: 'Characters',
    new: 'New character',
    createTitle: 'New character',
    editTitle: 'Edit character',
    dialogDescription: 'Maintain creative character fields. Engine tracking fields are updated by chapter workflows.',
    empty: 'No characters yet. Created characters will appear here.',
    loadFailed: 'Characters failed to load',
    created: 'Character created',
    updated: 'Character saved',
    deleted: 'Character deleted',
    saveFailed: 'Failed to save character. Try again later.',
    deleteFailed: 'Failed to delete character. Try again later.',
    deleteConfirm: 'Delete character "{{name}}"?',
    delete: 'Delete character',
    saving: 'Saving',
    protagonist: 'Protagonist',
    roleUnset: 'Role not set',
    tagPlaceholder: 'Press Enter to add',
    removeTag: 'Remove {{value}}',
    groups: {
      basic: 'Basic',
      profile: 'Profile',
      organization: 'Organization',
      other: 'Other',
    },
    fields: {
      name: 'Name',
      aliases: 'Aliases',
      role: 'Role',
      age: 'Age',
      gender: 'Gender',
      is_organization: 'Organization / group',
      role_type: 'Role type',
      personality: 'Personality',
      background: 'Background',
      appearance: 'Appearance',
      relationships: 'Relationships',
      inner_flaw: 'Inner flaw',
      identity_situation: 'Identity / situation',
      realm: 'Realm',
      realm_level: 'Realm level',
      motivation: 'Motivation',
      voice_signature: 'Voice signature',
      traits: 'Traits',
      organization_type: 'Organization type',
      organization_purpose: 'Organization purpose',
      organization_members: 'Organization members',
      notes: 'Notes',
      avatar_url: 'Avatar URL',
      status: 'Status',
    },
  },
  characterState: {
    title: 'Character states',
    subtitle: 'Shows the current snapshot and history timeline for the selected branch. Chapter generation updates it automatically.',
    branchPlaceholder: 'Select branch',
    tabs: {
      current: 'Current',
      history: 'History timeline',
    },
    empty: 'No character states yet. AI extracts them after chapters are generated.',
    historyEmpty: 'No character state history yet. The timeline appears after multiple generated chapters.',
    loadFailed: 'Character states failed to load',
    historyLoadFailed: 'Character state history failed to load',
    noFields: 'No state fields to show',
    timelineTitle: 'Character state history timeline',
    updatedThrough: 'Through chapter {{chapter}}',
    chapterBadge: 'Chapter {{chapter}}',
    openChapter: 'Open chapter {{chapter}}',
    evidenceEvent: 'Evidence event #{{id}}',
    fields: {
      level: 'Level',
      location: 'Location',
      physical_state: 'Physical',
      emotional_state: 'Emotional',
      equipment: 'Equipment',
      recent_events: 'Recent events',
      current_goal: 'Goal',
      pending_foreshadow: 'Pending foreshadowing',
      evidence_event: 'Evidence event',
    },
  },
  ingestReview: {
    evidenceMatch: { exact: 'Exact match', approximate: 'Approximate match' },
    identity: {
      independent: 'Confirm as independent', merge: 'Merge into existing entity', target: 'Target entity ID',
      mode: 'Entity review mode', review_new: 'Review new entities', review_all: 'Review all entity changes', auto_accept: 'Automatically accept new entities',
      pending: '{{count}} entities awaiting review · Open review', pendingLink: 'Pending entities · Open review',
      new_entity: 'New entity', entity_type_conflict: 'Entity type conflict', unknown_owner: 'Unresolved custodian',
      character: 'Character', location: 'Location', faction: 'Faction', item: 'Item', power: 'Power',
    },
    filters: {
      status: 'Status',
      chapter: 'Chapter',
      chapterPlaceholder: 'All',
    },
    columns: {
      chapter: 'Chapter',
      name: 'Character',
      aliases: 'Aliases',
      attributes: 'Key attributes',
      evidence: 'Evidence',
      status: 'Status',
      actions: 'Actions',
    },
    status: {
      all: 'All',
      pending: 'Pending',
      edited: 'Edited',
      accepted: 'Accepted',
      rejected: 'Rejected',
    },
    fields: {
      level: 'Level',
      equipment: 'Equipment',
      location: 'Location',
      emotional_state: 'Emotion',
      active_conflicts: 'Conflicts',
      relationships: 'Relationships',
    },
    accept: 'Accept',
    reject: 'Reject',
    batchAccept: 'Batch accept',
    batchReject: 'Batch reject',
    prev: 'Previous',
    next: 'Next',
    empty: 'No review items',
    loadFailed: 'Entity reviews failed to load',
    actionFailed: 'Review action failed. Try again later.',
    batchFailed: 'Batch action failed. Try again later.',
    saveFailed: 'Failed to save the edit. Try again later.',
    selectPage: 'Select current page',
    selectRow: 'Select {{name}}',
    editTitle: 'Edit {{name}}',
  },
  skeleton: {
    title: 'Skeleton planning',
    replanTitle: 'Replan skeleton',
    subtitle: 'Generate a volume and chapter scaffold draft from the target words. Nothing is saved until confirmation.',
    confirmedTitle: 'Confirmed skeleton',
    confirmedHint: 'This project already has saved volume outlines. Replanning creates a new draft first and saves it only after confirmation.',
    replan: 'Replan',
    targetWords: 'Target words',
    targetWordsPlaceholder: 'Defaults to the project target',
    chapterWordTarget: 'Chapter word target',
    chapterWordTargetPlaceholder: '{{value}} words suggested for this genre',
    propose: 'Generate skeleton',
    proposing: 'Generating',
    proposingHint: 'The model is planning the volume scaffold. This usually takes 1-3 minutes (longer for full-length works) — please wait and keep this page open.',
    proposeDone: 'Skeleton draft generated',
    proposeFailed: 'Failed to generate the skeleton. Try again later.',
    confirm: 'Confirm skeleton',
    confirming: 'Confirming',
    confirmDone: 'Skeleton confirmed',
    confirmFailed: 'Failed to confirm the skeleton. Try again later.',
    confirmHint: 'Confirmation saves the volume scaffold with {{value}} words per chapter.',
    loadFailed: 'Skeleton failed to load',
    noChaptersHint: 'This project has no chapters yet. Plan the skeleton first, then move into chapter generation.',
    summary: {
      totalChapters: 'Total chapters',
      volumeCount: 'Volumes',
      totalWords: 'Planned words',
    },
    volumeTitle: 'Volume {{value}}',
    chapterSingle: 'Ch. {{value}}',
    chapterRange: 'Ch. {{start}}-{{end}}',
    wordBudget: '{{value}} words',
    outline: 'Volume outline',
    outlinePlaceholder: 'Describe the volume arc, conflict progression, and ending hook.',
    emptyOutline: 'No volume outline',
    milestones: 'Milestones',
    addMilestone: 'Add milestone',
    addForeshadowPlant: 'Add plant',
    addForeshadowPayoff: 'Add payoff',
    removeForeshadow: 'Remove foreshadow',
    foreshadowKeyPlaceholder: 'Foreshadow name, e.g. “the broken-rib umbrella”',
    foreshadowDetailPlaceholder: 'What this foreshadow plants or pays off',
    removeMilestone: 'Remove milestone',
    milestonePlaceholder: 'Key event or turn',
    emptyMilestones: 'No milestones',
    foreshadowPlant: 'Foreshadowing plants',
    foreshadowPayoff: 'Foreshadowing payoffs',
    emptyForeshadow: 'No foreshadowing',
    prevPage: 'Previous',
    nextPage: 'Next',
    pageIndicator: 'Page {{page}} / {{total}}',
    edit: 'Edit skeleton',
    editTitle: 'Edit confirmed skeleton',
    editHint: 'Edit volume outlines and milestones directly. Saving overwrites the stored skeleton instantly without calling the model again.',
    save: 'Save changes',
    saving: 'Saving',
    updateDone: 'Skeleton updated',
    updateFailed: 'Failed to update the skeleton. Try again later.',
  },
  chapter: {
    number: 'No.',
    numberShort: 'Ch. {{value}}',
    chapterNumber: 'Chapter {{value}}',
    title: 'Chapter title',
    words: 'Words',
    wordsValue: '{{value}} words',
    status: 'Status',
    branch: 'Branch',
    untitled: 'Untitled chapter',
    loadFailed: 'Chapters failed to load',
    selectEmptyTitle: 'Select a chapter',
    selectEmptyBody: 'Choose a chapter from the tree to preview its title, status, word count, and content.',
    contentEmpty: 'This chapter has no content yet.',
    s2cHint: 'This basic preview supports reader typography, line width, and fullscreen reading controls.',
    review: {
      title: 'Consistency conflict needs review',
      description: 'This chapter has unresolved consistency conflicts, so completion was blocked. Resolve the conflicts on the consistency page, then resubmit.',
      conflictSummary: '{{count}} unresolved conflict: {{detail}}',
      conflictListTitle: '{{count}} unresolved conflict:',
      moreConflicts: '{{count}} more',
      severity: {
        hard: 'Hard conflict',
        soft: 'Soft conflict',
      },
      viewConflicts: 'View conflicts',
      resubmit: 'Resubmit review',
      resubmitted: 'Chapter resubmitted for review',
      badgeTitle: 'Consistency conflicts need resolution',
    },
    partialResult: {
      title: 'This chapter has partial content only',
      description: 'Downstream stations were treated as blocked. Regenerate this chapter or keep the current partial result for now.',
      regenerate: 'Regenerate chapter',
      keep: 'Keep',
      badgeTitle: 'This chapter has partial content only; downstream is blocked. Regenerate or keep it.',
    },
    refine: {
      action: 'Flagship refine',
      generated: 'Flagship refine generated',
      fallbackKept: 'Refine failed. The original draft was kept.',
    },
    version: {
      currentVersion: 'Current version',
      selectedVersion: 'Selected version',
      diffDirection: 'Comparison: current version ← → selected version',
      back: 'Back',
      keepDraft: 'Keep draft',
      adopt: 'Adopt',
      restore: 'Restore this version',
      sourceStale: 'Chapter text updated. Regeneration required.',
      keepDraftSuccess: 'Original draft kept',
      adoptSuccess: 'Flagship refine adopted',
      restoreSuccess: 'Version restored. The previous current version was saved to history.',
    },
    generate: {
      modeLabel: 'Generation mode',
      easyMode: 'Easy',
      advancedMode: 'Advanced',
      easyHint: 'One click: AI drafts this chapter outline and starts writing. It stops at this station — advancing to the next one is your call.',
      easyStart: 'Write next chapter',
      easyDrafting: 'Drafting outline',
      easyDetails: 'View / edit chapter parameters',
      easyDraftFailed: 'Outline drafting failed. Switch to Advanced to fill it in manually.',
      easyProjectUnavailable: 'Project data is still loading, try again shortly.',
      stationTitle: 'Chapter generation · stage 0 station',
      stageBadge: 'Chapter text · stage 0',
      formHint: 'Easy mode writes the chapter in one click; Advanced lets you fill in outline and parameters.',
      newChapter: 'New chapter',
      generatingDisabled: 'Generation is running',
      chapterNumber: 'Chapter number',
      title: 'Chapter title',
      titlePlaceholder: 'Optional. The completed chapter uses the backend title.',
      outline: 'Chapter outline',
      outlinePlaceholder: 'Describe the chapter events, emotional turn, and key scenes.',
      outlineRequired: 'Enter a chapter outline',
      outlineHint: 'The tree is not updated until the done event creates the chapter.',
      outlineLoadFailed: 'Failed to load the chapter outline',
      outlineSaveFailed: 'Failed to save the chapter outline',
      outlineConfirmFailed: 'Failed to confirm the chapter outline',
      outlineSaved: 'Chapter outline saved',
      outlineConfirmed: 'Chapter outline confirmed',
      outlineStatusDraft: 'Awaiting confirmation',
      outlineStatusConfirmed: 'Confirmed',
      outlineConfirmHint: 'Confirm the chapter outline before generating text.',
      outlineReadyHint: 'The chapter outline is confirmed and ready for text generation.',
      sceneBeats: 'Scene beats',
      keyEvents: 'Key events',
      characters: 'Characters',
      confirmOutline: 'Confirm outline',
      targetWords: 'Target words',
      mode: 'Chapter mode',
      lang: 'Language',
      creditEstimate: 'Generation credit estimate',
      creditEstimateValue: 'Estimated {{estimated}} / available {{available}}',
      creditEstimateUnavailable: 'Shown after outline confirmation',
      estimatingCredits: 'Estimating…',
      estimateFailed: 'Failed to estimate generation credits',
      insufficientCredits: 'Insufficient credits. Generation was blocked.',
      submit: 'Generate',
      abort: 'Cancel',
      abortConfirm: 'Generation is running. Interrupting will discard streamed content. Continue?',
      switchAwayConfirm: 'Generation is running. Switching chapters will interrupt it. Continue?',
      generatingChapter: 'Generating chapter {{value}}…',
      failedTitle: 'Chapter {{value}} generation failed',
      waitingForStream: 'Waiting for model output…',
      nonIdempotentHint: 'Failed generation can be retried safely; the idempotency lock prevents duplicate billing.',
      idempotentRetryHint: 'Disconnected streams recover automatically; manual retry reuses the chapter idempotency lock.',
      reconnecting: 'Connection interrupted. Recovering stream attempt {{value}}…',
      reconnectFailed: 'Generation stream recovery failed. Retry the request.',
      retry: 'Retry',
      errorMeta: 'Error type: {{category}} · {{code}}',
      invalidDonePayload: 'Generation completion event has an invalid shape',
      doneRefreshFailed: 'Chapter was generated. Refresh if the list does not update.',
      defaultsFailed: 'Could not load generation defaults. Reopen the form to retry.',
      downstreamManual: 'Completed. You can generate the screenplay manually in the production pipeline.',
      downstreamPulse: 'The downstream screenplay station will start pulsing',
      doneSummary: '"{{title}}" completed, {{words}} words, {{provider}}, {{duration}}',
      langs: {
        zh: '中文',
        en: 'English',
      },
    },
    statusValue: {
      unknown: 'Unknown',
      pending: 'Pending',
      done: 'Done',
      failed: 'Failed',
      needs_review: 'Needs review',
      partial_result: 'Partial result',
      passed: 'Passed',
    },
  },
  board: {
    title: 'Pulse Board',
    subtitle: 'Track chapter text jobs and media assets across the 6 PAL stations',
    view: {
      label: 'Board view',
      single: 'Single work',
      overview: 'Factory overview',
    },
    selectProject: 'Select project',
    emptyProjects: 'No projects to show',
    emptyJobs: 'No generation jobs for this project',
    emptyChapterTexts: 'No generated chapter text yet',
    emptyAssets: 'No assets in this station',
    emptyDrawerAssets: 'No assets are linked to this chapter yet',
    chapter: 'Chapter {{number}}',
    chapterTitle: 'Chapter {{number}} · {{title}}',
    chapterId: 'Chapter {{id}}',
    chapterUnknown: 'Unlinked chapter',
    segments: '{{current}}/{{total}} segments',
    runningSegments: '{{current}}/{{total}} segments',
    runningCount: 'Running {{count}}',
    stageSource: 'Source',
    stageSourceHint: 'Manuscript · chapter text',
    stageAdapt: 'Adaptation',
    stageAdaptHint: 'Screenplay · storyboard',
    stageProduce: 'Production',
    stageProduceHint: 'Image · audio · video',
    sectionGenerating: 'Generating',
    sectionGenerated: 'Generated chapters',
    sectionInFlight: 'In-flight chapters',
    attempts: 'Attempts',
    chapterMode: 'Chapter mode',
    wordCount: 'Words',
    noWordCount: 'N/A',
    quality: 'Quality',
    noQuality: 'N/A',
    qualityStatus: 'Status {{status}}',
    qualityLayer: 'Layer {{layer}}',
    qualityDegradedRatio: 'Degraded {{degraded}}/{{total}}',
    qualityDegraded: 'Degraded {{count}}',
    qualityRecorded: 'Quality info recorded',
    stageVersion: 'Stage / version',
    stageVersionValue: 'Stage {{stage}} · version {{version}}',
    stageValue: 'Stage {{stage}}',
    versionValue: 'Version {{version}}',
    jobDrawerTitle: 'Chapter {{chapter}} assets',
    assetDrawerTitle: '{{type}} details',
    jobId: 'Job ID',
    resultChapter: 'Result chapter',
    assetId: 'Asset ID',
    chapterAsset: 'Chapter',
    chapterAssetId: 'Chapter ID',
    createdAt: 'Created',
    updatedAt: 'Updated',
    assetPreview: 'Asset preview',
    assetDownload: 'Download',
    noPreviewAsset: 'No previewable asset',
    previewLoadFailed: 'Preview failed to load',
    mediaUnsupported: 'This browser does not support this media preview',
    chapterImageAlt: 'Chapter image',
    payloadJson: 'Developer details',
    developerDetails: 'Developer details',
  },
  overview: {
    title: 'Factory Overview',
    matrixTitle: 'Factory overview',
    project: 'Work',
    generating: 'Generating',
    awaitingConfirm: 'Awaiting',
    running: 'Running',
    empty: 'No active projects',
    loadFailed: 'Factory overview failed to load',
    projectTotals: '{{awaiting}} awaiting · {{generating}} generating',
    intervention: {
      message: '⚠️ {{projectCount}} works have {{chapterCount}} chapters awaiting action',
      action: 'Review',
    },
  },
  library: {
    title: 'Works Library',
    subtitle: 'Review each chapter’s finished station outputs with status filters and pagination.',
    selectProject: 'Select project',
    statusFilter: 'Filter status',
    total: '{{total}} chapters',
    empty: 'No chapters',
    untitled: 'Untitled',
    noWords: 'N/A',
    chapterTitle: 'Chapter {{number}} · {{title}}',
    columns: {
      chapter: 'Chapter',
      project: 'Work',
      status: 'Status',
      words: 'Words',
      updated: 'Updated',
    },
    modalitiesLabel: 'Output readiness',
    modalityReady: '{{modality}} ready',
    modalityMissing: '{{modality}} not ready',
    modalities: {
      screenplay: 'Screenplay',
      storyboard: 'Storyboard',
      panel_image: 'Images',
      audio: 'Audio',
      video: 'Video',
    },
    status: {
      all: 'All',
      done: 'Done',
      stopped: 'Stopped',
      awaiting_confirm: 'Awaiting confirmation',
    },
    statusValue: {
      unknown: 'Unknown',
      done: 'Done',
      completed: 'Done',
      complete: 'Done',
      finished: 'Done',
      stopped: 'Stopped',
      awaiting_confirm: 'Awaiting confirmation',
      running: 'Running',
      generating: 'Generating',
      streaming: 'Generating',
      writing: 'Writing',
      drafting: 'Drafting',
      needs_review: 'Needs review',
      partial_result: 'Partial result',
      failed: 'Failed',
    },
  },
  cascade: {
    reason: { already_running: 'This station is already running', policy_blocked: 'Current policy blocks continuation. Check pipeline settings.', not_enqueued: 'No new task started', other: 'No new task started: {{reason}}' },
    state: {
      running: 'Auto-running',
      awaiting_confirm: 'Paused for confirmation',
      stopped: 'Stopped',
    },
    actions: {
      continue: 'Continue',
      stop: 'Stop',
    },
    toast: {
      continued: 'Cascade continued',
      stopped: 'Cascade stopped',
    },
  },
  station: {
    text: 'Text',
    screenplay: 'Screenplay',
    storyboard: 'Storyboard',
    image: 'Image',
    audio: 'Audio',
    video: 'Video',
  },
  assetStatus: {
    pending: 'Pending',
    passed: 'Passed',
    needs_review: 'Needs review',
    failed: 'Failed',
    isolated: 'Isolated',
  },
  assetType: {
    chapter_text: 'Text',
    screenplay: 'Screenplay',
    storyboard: 'Storyboard',
    panel_image: 'Image',
    character_design: 'Character design',
    audio: 'Audio',
    video: 'Video',
    config: 'Config',
  },
  payload: {
    quality: 'Quality',
    score: 'Score',
    title: 'Title',
    summary: 'Summary',
    url: 'URL',
    image_url: 'Image URL',
    audio_url: 'Audio URL',
    video_url: 'Video URL',
    duration: 'Duration',
    duration_ms: 'Duration (ms)',
    word_count: 'Word count',
    panel_count: 'Panel count',
    scene_count: 'Scene count',
  },
  job: {
    status: {
      pending: 'Pending',
      structure_planning: 'Planning structure',
      paragraph_generating: 'Generating paragraphs',
      qc_check: 'QC check',
      copy_editing: 'Copy editing',
      scene_editing: 'Scene editing',
      retry_scheduled: 'Retry scheduled',
      done: 'Done',
      failed: 'Failed',
      needs_review: 'Needs review',
      partial_result: 'Partial result',
    },
  },
  submitJob: {
    open: 'Submit chapter job',
    title: 'Submit chapter job',
    description: 'Submit one chapter or a batch of chapters into the generation queue.',
    mode: 'Submit mode',
    singleMode: 'Single',
    batchMode: 'Batch',
    chapterNo: 'Chapter number',
    chapterNoRequired: 'Enter a chapter number',
    startChapterNo: 'Start chapter',
    startChapterNoRequired: 'Enter a start chapter',
    chapterCount: 'Chapter count',
    chapterCountRequired: 'Enter chapter count',
    chapterCountHint: 'Submit 1-{{max}} chapters at once',
    outline: 'Chapter outline',
    sharedOutline: 'Shared chapter outline',
    outlineRequired: 'Enter a chapter outline',
    targetWords: 'Target words',
    targetWordsRequired: 'Enter target words',
    wordsHint: 'Target words must be between {{min}} and {{max}}. Default {{defaultValue}}',
    chapterMode: 'Chapter mode',
    chapterModeRequired: 'Select a chapter mode',
    volumeNo: 'Volume number',
    volumeNoHint: 'Optional. Defaults to volume 1',
    lang: 'Generation language',
    submit: 'Submit',
    submitted: 'Chapter generation job submitted',
    batchSubmitted: '{{count}} chapter generation jobs submitted',
  },
  jobChapterMode: {
    regular: 'Regular',
    climax: 'Climax',
    thematic: 'Thematic',
    volume_opening: 'Volume opening',
    volume_finale: 'Volume finale',
  },
  generate: {
    title: 'Generate chapter now',
    writeNext: 'Write next chapter',
    drafting: 'Planning the next chapter',
    customize: 'Expand and adjust chapter details',
    hideDetails: 'Hide chapter details',
    draftFailed: 'Could not draft the next chapter. Fill in the details and try again.',
    chapterNumber: 'Chapter number',
    chapterNumberRequired: 'Enter a chapter number',
    chapterTitle: 'Chapter title',
    outline: 'Chapter outline',
    outlineRequired: 'Enter a chapter outline',
    targetWords: 'Target words',
    chapterMode: 'Chapter mode',
    start: 'Start generation',
    generating: 'Generating',
    preview: 'Streaming preview',
    completed: 'Chapter generated',
    readNow: 'Read now',
    invalidDonePayload: 'Generation completion event has an invalid shape',
    doneSummary: '"{{title}}" completed, {{words}} words, {{provider}}, {{duration}}',
    wordCountEstimate: 'Estimated range {{range}} words (target {{target}})',
    wordCountActualRange: 'Actual {{actual}} words; target range {{min}}-{{max}}',
    wordCountUnderWarning: 'The generated chapter is below the estimated range by {{delta}} words.',
    wordCountOverWarning: 'The generated chapter is above the estimated range by {{delta}} words.',
  },
  reader: {
    title: 'Reader',
    openReader: 'Reader',
    close: 'Close',
    toc: 'Table of contents',
    tocDescription: 'Chapters in "{{title}}"',
    tocLoading: 'Loading chapters',
    emptyToc: 'No readable chapters yet.',
    chapterProgress: 'Chapter progress',
    readingProgress: 'Reading progress',
    pickChapterTitle: 'Choose a chapter from the TOC',
    pickChapterDescription: 'The table of contents is open. Jump to any chapter to review the finished prose.',
    loadFailed: 'Failed to load reader',
    backToProject: 'Back to project',
    backToToc: 'TOC',
    branch: 'Branch',
    theme: 'Reading theme',
    paperTheme: 'Paper',
    nightTheme: 'Night',
    export: 'Export',
    exporting: 'Exporting',
    exportFormat: 'Export format',
    exportDone: 'Export download started',
    exportFailed: 'Export failed',
    exportFormats: {
      epub3: 'EPUB 3',
      txt: 'TXT',
      md: 'Markdown',
      fdx: 'FDX',
      fountain: 'Fountain',
      pdf: 'PDF',
      'bilingual-md': 'Bilingual Markdown',
      'bilingual-docx': 'Bilingual DOCX',
    },
    exportCenter: {
      title: 'Export center',
      description: 'Export the whole project in reader, publishing, and professional screenplay formats.',
      primary: 'Primary',
      comingSoon: 'Coming soon',
      exportAction: 'Export',
      goldenContract: 'Golden contract: compliant Final Draft FDX for professional screenplay handoff.',
      formats: {
        fdx: {
          title: 'FDX',
          description: 'Professional screenplay package for Final Draft and production workflows.',
        },
        'bilingual-md': {
          title: 'Bilingual MD',
          description: 'Translate the screenplay and export line-by-line Chinese-English Markdown in the Ming Men format.',
        },
        'bilingual-docx': {
          title: 'Bilingual DOCX',
          description: 'Translate the screenplay and export a Word document with named styles and italic voice-over lines.',
        },
        epub3: {
          title: 'EPUB 3',
          description: 'Reflowable ebook package for reading apps and distribution checks.',
        },
        md: {
          title: 'Markdown',
          description: 'Portable manuscript source for editing, versioning, and downstream conversion.',
        },
        txt: {
          title: 'TXT',
          description: 'Plain text export for lightweight review and archival pipelines.',
        },
        fountain: {
          title: 'Fountain',
          description: 'Plain-text screenplay format for human-readable scripts popular with independent screenwriters.',
        },
        pdf: {
          title: 'PDF',
          description: 'Fixed-layout proofing placeholder for a later print-ready exporter.',
        },
      },
    },
    tab: {
      label: 'Reader content',
      text: 'Text',
      comic: 'Comic',
      video: 'Video',
    },
    emptyScript: 'No script for this chapter yet',
    emptyStoryboard: 'No storyboard for this chapter yet',
    script: {
      sceneFallback: 'Scene {{index}}',
      unknownSpeaker: 'Character',
      jumpToStoryboard: 'View storyboard',
      jumpToStoryboardScene: 'View storyboard for {{scene}}',
    },
    storyboard: {
      panelNo: 'Shot {{number}}',
      imagePending: 'Image pending',
      imageAlt: 'Panel image',
      jumpToScene: 'Jump to script scene {{scene}}',
      transition: 'Transition',
    },
    consume: {
      comicEmpty: 'No comic panels for this chapter yet. Generate storyboard panels in the workspace first.',
      comicPanelAlt: 'Comic panel {{number}}',
      videoEmpty: 'Video has not been generated for this chapter yet. Generate it in the workspace first.',
      videoGenerate: 'Generate video',
      videoUnsupported: 'Your browser does not support video playback.',
    },
    modalities: {
      text: 'Text',
      image: 'Image',
      audio: 'Audio',
      video: 'Video',
    },
    chapterNumber: 'Chapter {{number}}',
    untitled: 'Untitled chapter',
    headerImageAlt: 'Chapter header image',
    audioUnsupported: 'Your browser does not support audio playback.',
    settings: 'Reading settings',
    chapterHeading: 'Chapter {{number}}: {{title}}',
    fontSize: 'Font size: {{size}}px',
    fontSizeLabel: 'Font size',
    lineHeight: 'Line height: {{value}}',
    fontFamily: 'Reading font',
    fontKai: 'Kai',
    fontSong: 'Song',
    previous: 'Previous',
    next: 'Next',
    wordCount: '{{value}} words',
    firstChapter: 'First chapter',
    lastChapter: 'Last chapter',
  },
  pagination: {
    range: 'Showing {{start}}-{{end}} / {{total}} total',
    single: 'Showing {{index}} / {{total}} total',
    page: '{{page}} / {{total}}',
    pageWithUnit: '{{page}} / {{total}} pages',
    totalAssets: '{{total}} assets total',
    totalImages: '{{total}} images total',
    pageSize: 'Per page',
    first: 'First page',
    previous: 'Previous page',
    next: 'Next page',
    last: 'Last page',
  },
  consistencyDashboard: {
    recordedAt: 'Conflict recorded: {{time}}',
    referenceInvalid: 'Reference no longer valid',
    cleanupReference: 'Clean up invalid reference',
    cleanupConfirm: 'Close this invalid reference conflict? Its history will be retained.',
    recheckRegistration: 'Recheck registration',
    recheckConfirm: 'Recheck the current location registration? This conflict will close if the original rule is satisfied. History is retained.',
    reviewResolved: 'Conflict closed; history retained',
    reviewFailed: 'Unable to close conflict. Check the location registration and introduction chapter.',
    title: 'Consistency dashboard',
    subtitle: 'Current project: {{project}}',
    noProject: 'Create a project first',
    loadFailed: 'Failed to load consistency conflicts',
    chapterNo: 'Chapter {{chapter}}',
    projectPicker: {
      label: 'Project',
      placeholder: 'Select project',
      noProjects: 'Create a project first',
    },
    stats: {
      hard: 'Hard {{count}}',
      soft: 'Soft {{count}}',
      overridden: 'Overridden {{count}}',
    },
    filters: {
      severity: 'Severity',
      all: 'All',
      chapter: 'Chapter number',
      chapterPlaceholder: 'All chapters',
      clearChapter: 'Clear chapter',
    },
    severity: {
      hard: 'Hard',
      soft: 'Soft',
    },
    softStatus: {
      title: 'Chapter consistency status',
      running: 'Soft consistency check running…',
      done_flagged: '{{count}} suggestion found',
      done_clean: '✓ No soft consistency issues',
      failed: 'Check incomplete, retry available',
      none: 'Not checked',
      disabled: 'Turned off',
    },
    softRules: {
      ooc: 'Character drift',
      setting: 'Soft setting contradiction',
      emotion: 'Emotional logic break',
    },
    experimentalBadge: 'Experimental · review suggested',
    fields: {
      rule: 'Rule:',
      entity: 'Entity:',
    },
    actions: {
      viewContext: 'View context',
      override: 'Override',
      markLongTerm: 'Mark long-term',
      openChapter: 'Open chapter',
      openChapterTitle: 'Open the chapter containing this conflict',
      resubmit: 'Resubmit',
      partialRewrite: 'AI rewrite',
    },
    longTerm: {
      title: 'Mark as a long-term foreshadow',
      hint: 'A long-term foreshadow may span volumes, but it may not go without a deadline. Give it a payoff chapter; it reopens if that passes. Everything still unsettled is listed at the end of the book — long-term ones included.',
      chapterLabel: 'Pay it off by which chapter',
      chapterPlaceholder: 'e.g. 10',
      chapterHint: 'Must be later than this chapter. If it is still unresolved by then, this blocks again.',
      submit: 'Mark long-term',
      saved: 'Marked as long-term',
    },
    override: {
      title: 'Mark as valid exception',
      warning: 'An exception does not switch the check off — it records a debt with a deadline. Give a reason and the chapter by which you promise to explain it; it reopens automatically if that passes.',
      dueChapterLabel: 'Explain it by which chapter',
      dueChapterPlaceholder: 'e.g. 9',
      dueChapterHint: 'If it is still unexplained by then, this conflict reopens automatically. Everything still unsettled is listed at the end of the book.',
      placeholder: 'Enter override reason',
      submit: 'Submit override',
      overridden: 'Overridden',
      noReason: 'No reason recorded',
      reasons: {
        intentionalLongArc: 'Intentional long arc',
      },
    },
    empty: {
      title: 'Canon consistent',
      description: 'This project has no consistency conflicts.',
      filteredTitle: 'No conflicts match these filters',
      filteredDescription: 'Adjust severity or chapter filters to view other conflicts.',
    },
    messages: {
      overrideSaved: 'Override saved',
      resubmitted: 'Chapter resubmitted',
      chapterMissing: 'Matching chapter not found',
      rewriteNoContent: 'This chapter has no rewriteable content',
    },
  },
  conflictContext: {
    title: 'Conflict context',
    detailLabel: 'Conflict detail',
    earliestTrigger: 'Earliest trigger chapter · Chapter {{chapter}}{{title}}',
    latestTrigger: 'Latest trigger chapter · Chapter {{chapter}}{{title}}',
    sameContentHint: 'Both excerpts are identical. The actual canon drift may be in an intervening chapter; use the conflict detail above.',
    entityNotLocated: 'Could not locate "{{entity}}" in the chapter text. It may use an alias, abbreviation, or typo.',
    entityApproximate: 'The chapter text never says "{{entity}}"; the closest wording is "{{matched}}" (highlighted). If the text reads as ordinary narration rather than a proper name, extraction most likely mistook it for an entity.',
    chapterMissing: 'Matching chapter not found.',
    noContent: 'This chapter has no content.',
  },
  relationGraph: {
    loadFailed: 'Relation graph failed to load',
    empty: 'No relation data yet. After chapters are generated or memory is imported, character, item, location, and faction relations appear here.',
    causalityEmpty: 'No causal chain data yet. Strong causal events will appear here after chapter memory extraction runs.',
    views: {
      relations: 'Relations',
      causality: 'Causality',
    },
    snapshot: {
      label: 'Chapter snapshot',
      all: 'All relations',
      chapter: 'Chapter {{chapter}}',
    },
    export: {
      title: 'Entity relation graph',
      causalityTitle: 'Event causality graph',
      svg: 'Export SVG',
    },
    legend: {
      nodes: 'Nodes',
      edges: 'Relations',
    },
    detail: {
      title: 'Node detail',
      relatedEdges: 'Related edges',
      noRelatedEdges: 'No related edges',
      jumpCharacterState: 'Open character state',
      jumpChapter: 'Open chapter',
      eventType: 'Event type',
      chapter: 'Chapter',
      characterReadOnlyFallback: 'Character detail could not be loaded. Showing read-only basic information.',
      save: 'Save canon',
      saveSuccess: 'Canon saved',
      saveFailed: 'Canon save failed',
      fields: {
        name: 'Name',
        aliases: 'Aliases',
        role: 'Role',
        personality: 'Personality',
        motivation: 'Motivation',
        realm: 'Realm',
        realmLevel: 'Realm level',
        background: 'Background',
        appearance: 'Appearance',
        status: 'Status',
        type: 'Type',
      },
    },
    foreshadow: {
      title: 'Foreshadow tracking',
      summary: '{{unresolved}} unresolved / {{total}} total',
      empty: 'No foreshadow edges yet.',
      loadFailed: 'Foreshadows failed to load',
      setChapter: 'Set chapter: {{chapter}}',
      unresolved: 'Unresolved',
      resolvedAt: 'Resolved @ chapter {{chapter}}',
      jump: 'Open chapter',
      resolve: 'Resolve',
      resolveTitle: 'Resolve foreshadow',
      resolveChapter: 'Resolve chapter',
      resolveSuccess: 'Foreshadow resolved',
      resolveFailed: 'Foreshadow resolve failed',
    },
    nodeTypes: {
      character: 'Character',
      faction: 'Faction',
      item: 'Item',
      location: 'Location',
      power: 'Power',
      event: 'Event',
      foreshadow: 'Foreshadow',
      chapter: 'Chapter',
      unknown: 'Unknown',
    },
    eventTypes: {
      character_introduce: 'Character introduced',
      character_evolve: 'Character changed',
      location_introduce: 'Location introduced',
      location_update: 'Location updated',
      plot_advance: 'Plot advance',
      plot_resolve: 'Plot resolved',
      timeline_event: 'Timeline event',
      chapter_control_card: 'Chapter control card',
      power_introduce: 'Power introduced',
      power_cultivate: 'Power cultivated',
      power_breakthrough: 'Power breakthrough',
      faction_introduce: 'Faction introduced',
      faction_relation: 'Faction relation',
      entity_edge: 'Entity relation',
      item_introduce: 'Item introduced',
      item_transfer: 'Item transferred',
      item_destroy: 'Item destroyed',
    },
    edgeTypes: {
      master_of: 'Master of',
      disciple_of: 'Disciple of',
      rival_of: 'Rival of',
      ally_of: 'Ally of',
      family_of: 'Family of',
      lover_of: 'Lover of',
      located_at: 'Located at',
      member_of: 'Member of',
      owns: 'Owns',
      wields: 'Wields',
      cultivates: 'Cultivates',
      contains: 'Contains',
      adjacent_to: 'Adjacent to',
      ally_with: 'Allied with',
      war_with: 'At war with',
      vassal_of: 'Vassal of',
      foreshadows: 'Foreshadows',
      combat_with: 'In combat with',
      allied: 'Allied',
      ally: 'Allied',
      hostile: 'Hostile',
      enemy: 'Enemy',
      holds: 'Holds',
      mentor: 'Mentor',
      loves: 'Affection',
      causes: 'Causes',
      default: 'Other',
    },
  },
  partialRegenerate: {
    title: 'AI partial rewrite',
    toolbarAction: 'AI rewrite',
    toolbarTooltip: 'Rewrite the selected text',
    selectedCount: '{{value}} selected',
    original: 'Original',
    rewritten: 'Rewritten',
    instruction: 'Rewrite instruction',
    instructionPlaceholder: 'Describe the rewrite, such as deeper interiority, tighter pacing, or a different character voice',
    lengthMode: 'Length mode',
    targetChars: 'Target characters',
    targetCharsRequired: 'Enter a target character count',
    generate: 'Generate',
    regenerate: 'Regenerate',
    apply: 'Apply',
    discard: 'Discard',
    applied: 'Rewrite applied',
    discarded: 'Rewrite discarded',
    streamingPreview: 'Streaming preview',
    diffPreview: 'Diff preview',
    waiting: 'Waiting for model output…',
    invalidDonePayload: 'Partial rewrite completion event has an invalid shape',
    freeformInstructionRequired: 'Freeform mode requires an instruction',
    modes: {
      similar: 'Similar',
      expand: 'Expand',
      condense: 'Condense',
      custom: 'Custom',
      freeform: 'Instruction',
    },
  },
  markdown: {
    empty: 'No content yet',
    imageAlt: 'Chapter image',
  },
  status: {
    common: {
      unknown: 'Unknown',
      custom: '{{status}}',
    },
    project: {
      planning: 'Planning',
      writing: 'Writing',
      in_progress: 'In progress',
      paused: 'Paused',
      completed: 'Completed',
      archived: 'Archived',
    },
    chapter: {
      done: 'Completed',
      completed: 'Completed',
      complete: 'Completed',
      finished: 'Completed',
      stopped: 'Stopped',
      awaiting_confirm: 'Awaiting confirmation',
      needs_review: 'Needs review',
      partial_result: 'Partial result',
      running: 'In progress',
      generating: 'Generating',
      streaming: 'Generating',
      writing: 'Writing',
      drafting: 'Drafting',
      failed: 'Failed',
    },
    job: {
      pending: 'Pending',
      structure_planning: 'Planning structure',
      paragraph_generating: 'Generating paragraphs',
      qc_check: 'Quality check',
      copy_editing: 'Copy editing',
      scene_editing: 'Scene editing',
      retry_scheduled: 'Retry scheduled',
      done: 'Completed',
      failed: 'Failed',
      needs_review: 'Needs review',
      partial_result: 'Partial result',
    },
    asset: {
      pending: 'Pending',
      passed: 'Passed',
      needs_review: 'Needs review',
      needs_review_attention: '⚠️ Review pending',
      failed: 'Failed',
      isolated: 'Isolated',
    },
    cascade: {
      running: 'In progress',
      awaiting_confirm: 'Awaiting confirmation',
      stopped: 'Stopped',
    },
    quality: {
      passed: 'Passed',
      done: 'Done',
      failed: 'Failed',
      needs_review: 'Needs review',
      partial_result: 'Partial result',
      unknown: 'Unknown',
    },
  },
  projectStatus: {
    planning: 'Planning',
    writing: 'Writing',
    in_progress: 'In Progress',
    paused: 'Paused',
    completed: 'Completed',
    archived: 'Archived',
  },
  state: {
    running: 'running',
    done: 'done',
    failed: 'failed',
    needs_review: 'needs review',
    partial_result: 'partial',
  },
}
